import {
  FRESH,
  FRESH_ADD,
  SHOW_TOAST,
  FRESH_VIDEOS,
  GET_POE,
  GET_POINTS,
  CLEAR_POINTS,
  FB_URL
} from './../actions/types'
import firebase from '../firebase'
import { _toArrayUsers } from './commonActions'
import moment from 'moment-timezone';
import thunk from 'redux-thunk';
import { getActiveLcSettings } from '../../utils/lc_settings'
import axios from 'axios';
import { CommentsDisabledOutlined } from '@mui/icons-material';

 export const insertNewUserdata = (params) => {
  let userData
  let database = firebase.database
  const updates = {}
  return (dispatch, getState) => {
    // Insert/replace in daylyThoughts collection
    updates['/dailyThoughts/' + params.thoughtid + '/points'] = params.points
    database
      .ref()
      .update(updates)
      .then(() => {
        dispatch({
          type: 'FRESH_ADD'
        })
      })
      .catch((err) => {
        dispatch({
          type: 'FRESH_ADD'
        })
      })
  }
}

 export const insertNewVideoUserdata = (params) => {
  let userData
  let database = firebase.database
  const updates = {}
  return (dispatch, getState) => {
    // Insert/replace in daylyThoughts collection
    updates['/videos/' + params.thoughtid + '/points'] = params.points
    database
      .ref()
      .update(updates)
      .then(() => {
        dispatch({
          type: 'FRESH_VIDEOS'
        })
      })
      .catch((err) => {
        dispatch({
          type: 'FRESH_VIDEOS'
        })
      })
  }
}

function formatDate(date) {
  let d = new Date(date)


  let month = '' + (d.getMonth() + 1)


  let day = '' + d.getDate()


  let year = d.getFullYear()

  if (month.length < 2) {
    month = '0' + month
  }
  if (day.length < 2) {
    day = '0' + day
  }

  return [year, month, day].join('-')
}

const updateLeads = params => {
  return (dispatch, getState) => {
    firebase.database
      .ref('dailyThoughts')
      .orderByChild('journalUserID')
      .equalTo(params.userID)
      .on('value', function (data) {
        if (data.val()) {
          let data = data.val()
          let receivedData = {}
          delete data.undefined
          if (Object.keys(data).length > 0) {
            let sortedData = _toArrayUsers(data)

            sortedData.sort(function (a, b) {
              if (a.points > b.points) {
                return 1
              }
              if (a.points < b.points) {
                return -1
              }
              return 0
            })

            receivedData = { ...sortedData }

            receivedData = Object.assign({}, sortedData)
          }

          dispatch({
            type: GET_POE,
            poe: receivedData
          })
        } else {
          dispatch({
            type: GET_POE,
            poe: {}
          })
        }
      })
  }
}

      const getDaysInCurrentMonth = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = now.getMonth() + 1; // getMonth() returns 0-11, so add 1 to get 1-12
      
        // Create a new date object set to the first day of the next month, then subtract one day to get the last day of the current month
        const nextMonth = new Date(year, month, 1);
        const lastDayOfCurrentMonth = new Date(nextMonth - 1);
        const totMonthdays = lastDayOfCurrentMonth.getDate() + 1;
        return totMonthdays;
      };
      
      // === Server-time helpers for LC limits ===
      // Cache for server offset so we don't hit .info/serverTimeOffset on every call
      let SERVER_TIME_OFFSET_MS = null;
      
      const getServerNow = async () => {
        const database = firebase.database;
        try {
          if (SERVER_TIME_OFFSET_MS === null) {
            const serverTimeRef = database.ref('.info/serverTimeOffset');
            const timeSnapshot = await serverTimeRef.once('value');
            const offset = timeSnapshot.val() || 0;
            SERVER_TIME_OFFSET_MS = offset;
          }
        } catch (e) {
          // If we can't read server offset, fall back to zero (client time).
          SERVER_TIME_OFFSET_MS = 0;
        }
        return new Date(Date.now() + (SERVER_TIME_OFFSET_MS || 0));
      };
      
      // Per-user daily cap enforcement helpers (use SERVER TIME, not client clock)
      const getBusinessDayString = async () => {
        try {
          const serverNow = await getServerNow(); // trusted server time
          const timeRaw = moment(serverNow).tz('Africa/Johannesburg');
          return timeRaw.format('YYYY-MM-DD');
        } catch (e) {
          // Fallback: client time in SAST
          try {
            const fallback = moment().tz('Africa/Johannesburg');
            return fallback.format('YYYY-MM-DD');
          } catch (_) {
            // Last-resort fallback: UTC calendar date string
            const d = new Date();
            const y = d.getUTCFullYear();
            const m = String(d.getUTCMonth() + 1).padStart(2, '0');
            const day = String(d.getUTCDate()).padStart(2, '0');
            return `${y}-${m}-${day}`;
          }
        }
      };
 
      const getDailyUserLimitLc = () => {
        try {
          const s = getActiveLcSettings();
          return typeof s.dailyUserLimitLc === 'number' ? s.dailyUserLimitLc : 2;
        } catch (e) {
          return 2;
        }
      };
  
    // async function canAwardUserToday(userID, pointsAdded, newPaddedDate) {
    //     // Allow deductions and zero awards
    //     if (Number(pointsAdded) <= 0) return true;
    //     const awardLc = Number(pointsAdded) / 100;
    //     const limitLc = getDailyUserLimitLc();

    //   }

      // async function canAwardUserToday_old(userID, pointsAdded) {
      //   // Allow deductions and zero awards
      //   if (Number(pointsAdded) <= 0) return true;
      //   const awardLc = Number(pointsAdded) / 100;
      //   const limitLc = getDailyUserLimitLc();
      //   const dayKey = await getBusinessDayString(); // use server-based business day
      //   const database = firebase.database;
      //   try {
      //     const snap = await database.ref('usersDailyEarnings').child(dayKey).child(userID).once('value');
      //     const earnedToday = Number(snap.val() || 0);
      //     return (earnedToday + awardLc) <= limitLc;
      //   } catch (e) {
      //     // If we cannot read, fail-open to avoid blocking users
      //     return true;
      //   }
      // }
 
// NOTE: For security, writes to `usersDailyEarnings` are handled **only** by backend/Admin SDK,
// via the `m115-freshcard` HTTPS function. The client never writes directly to the RTDB path,
// which allows `"usersDailyEarnings": { ".write": false }` to remain in the rules.
async function recordUserDailyEarnings(userID, pointsAdded, thisDay) {
  try {
    const pts = Number(pointsAdded || 0);
    // Only record positive earnings – reversals/unlikes should not reduce the daily total
    if (!userID || !isFinite(pts) || pts <= 0) return;

    // Convert internal points to LC (1 LC = 100 points)
    const awardLc = pts / 100;
    if (awardLc <= 0) return;

    // Use the same server-time based business day as the checker
    const dayKey = thisDay;//await getBusinessDayString();
    
    const database = firebase.database;

    // Read current total for this user/day (read is allowed by rules)
    const snap = await database
      .ref('usersDailyEarnings')
      .child(dayKey)
      .child(userID)
      .once('value');

    const earnedToday = Number(snap.val() || 0);
    const newTotal = Number((earnedToday + awardLc).toFixed(6));

    // Persist via backend Admin SDK so RTDB rules can stay locked down
    const updates = {};
    updates[`usersDailyEarnings/${dayKey}/${userID}`] = newTotal;
// params: { updates: updates } 
    // await axios.post(
    //   `${FB_URL}/m121-freshpoints`,
    //   { params: { updates } },
    //   { timeout: 8000 }
    // );
          var res = await axios.post(`${FB_URL}/m121-freshcard`, {
              params: {
                 updates: updates //user wallet address                      
              }
          })
        if (res.data || res.data.success === true) {
          console.log('recordUserDailyEarnings success')
          }
          else{
            console.log('recordUserDailyEarnings fail')
          }
  } catch (e) {
    try {
      console.error('[recordUserDailyEarnings] failed:', e.message || e);
    } catch (_) {}
  }
}

      async function PassLC() {
        var addLC = false;
        const dateObj = new Date();
        var dayquota;
        //var Maxday;
        
       // const day = dateObj.getUTCDate();
        let database = firebase.database;
      
        try {
          const snapshot = await database.ref('patreon').once('value');
          const patreon = snapshot.val();  
      
          const LCtoday = patreon.LCtoday;
         // const lc_pool = patreon.LCPOOL;
          const dayquota = patreon.limit;

          //const Maxday = getDaysInCurrentMonth(); // Corrected function call        
          
         // dayquota = (lc_pool * (0.9)) / (parseInt(Maxday) - parseInt(day)); 
         // console.log('PassLC compare: ', LCtoday + ' -- ' + dayquota);   

          if (LCtoday < dayquota) {
            
            addLC = true;
          } else {
            
            addLC = false;
          }
          
          return addLC;
        } catch (error) {
          
          return false;
        }
      }

     async function limitIs() {
        var addLC = 0;

        let database = firebase.database;
      
        try {
          const snapshot = await database.ref('patreon').once('value');
          const patreon = snapshot.val();  
      
          const dayquota = patreon.limit;

          if (dayquota) {          
            addLC = dayquota;
          } else {         
            addLC = 0;
          }
          
          return addLC;
        } catch (error) {
          
          return false;
        }
      }     

      async function PassLC_default() {
        var addLC = false;
        const dateObj = new Date();
        var dayquota;
        //var Maxday;
        
        const day = dateObj.getUTCDate();
        let database = firebase.database;
      
        try {
          const snapshot = await database.ref('patreon').once('value');
          const patreon = snapshot.val();  
      
          const LCtoday = patreon.LCtoday;
          const lc_pool = patreon.LCPOOL;

          const Maxday = getDaysInCurrentMonth(); // Corrected function call        
          
          dayquota = (lc_pool * (0.9)) / (parseInt(Maxday) - parseInt(day));
                        
          if (LCtoday < dayquota) {
            
            addLC = true;
          } else {
            
            addLC = false;
          }
          
          return addLC;
        } catch (error) {
          
          return false;
        }
      }

    //   async function PassLC() {
    //     var addLC = false;
    //     const dateObj = new Date();
    //     var dayquota;
    //     //var Maxday;
    //     const day = dateObj.getUTCDate();
    //     let database = firebase.database;
    
    //     try {
    //         const snapshot = await database.ref('patreon').once('value');
    //         const patreon = snapshot.val();
    //         // if(patreon) {
    //         //   const LCtoday = patreon.LCtoday;
    //         //   const lc_pool = patreon.LCPOOL;
    //         // }else {
    //         // }

    //         const LCtoday = patreon.LCtoday;
    //         const lc_pool = patreon.LCPOOL;

    //          const Maxday = getDaysInCurrentMonth;

    //         dayquota = (lc_pool * (0.9)) / (parseInt(Maxday) - parseInt(day));
    //         if (LCtoday < dayquota) {
    //             addLC = true;
    //         } else {
    //             addLC = false;
    //         }
    //         return addLC;
    //     } catch (error) {
    //         return false;
    //     }
    // }

  ///////////////////////////////////////////////////////////////////  
  //   npm install bcryptjs
    
  //   import CryptoJS from 'crypto-js';
  //   import {
  //    FB_URL
  //   } from './../actions/types'
  //   import axios from 'axios';    
  ///////////////////////////////////////////////////////////////////
  // const encryptUserData = async (uid, userID, field, val) => {
  //   var encryptedval = btoa(CryptoJS.AES.encrypt(val, 'secret').toString());
  //   var updates = {};
  //   updates['/user/' + uid + '/' + field] = encryptedval
  //   updates['/users/' + userID + '/' + field] = encryptedval

  //         var res = await axios.post(`${FB_URL}/m115-freshcard`, {
  //               params: {
  //                   updates: updates, //user wallet address                       
  //               }
  //         })

  //     if (res.data || res.data.success === true) {
  //        console.log('update success');
  //   } else {
  //     console.error('update fail');
  //   }

  // }

  // const decryptUserData = async (hashval) => {
  //   const decrypt = CryptoJS.AES.decrypt(atob(hashval), 'secret').toString(CryptoJS.enc.Utf8);

  //     if (decrypt) {
  //        console.log('update success');
  //        return decrypt;
  //   } else {
  //     console.error('update fail');
  //     return 'xxxxx';
  //   }

  // }
  ///////////////////////////////////////////////////////////////////
  
  const updateDatabase = async (path, newData, setLocalState) => {
      const dbRef = ref(database, path);
    
      try {
        await set(dbRef, newData); // ✅ Update Firebase
        setLocalState(newData); // ✅ Update React state immediately
      } catch (error) {
        
      }
    };   

async function canAwardUserToday(userUid, pointsAdded, newPaddedDate, pointsLim) {
     var updates = {};
     // if (Number(pointsAdded) <= 0) return true;
      var canLc = true;
     // const awardLc = Number(pointsAdded) / 100;
     // const pointsLim = getDailyUserLimitLc();
      const LimitIs = pointsLim * 100;

   console.log('likesPoints 4a: LimitIs:', LimitIs + ' - userUid:' + userUid + ' - pointsAdded:' + pointsAdded + ' - newPaddedDate:' + newPaddedDate);
      const snap = await firebase.database.ref(`/user/${userUid}`).once('value');
      const data = snap.val() || {};

      // ── Decide logic ─────────────────────────────────
      const storedDate = data.lctime || '';  
      const pointsToday = data.pointsToday || ''; 

        if (!Number.isFinite(pointsToday) || !Number.isFinite(pointsAdded)) {
         // throw new Error("Invalid numeric input");
         console.log('pointsToday invalid numeric input')
         return false;
        }

      // ── Parse safely ─────────────────────────────────
      //const currentToday  = pointsToday / 100;//Number(data)  || 0;

      const isSameDay  = storedDate === newPaddedDate;

      var addpoints;

      if (isSameDay) { 
       if (pointsToday > LimitIs) { // stop
          canLc = false;
           console.log('freshcardLog canAwardUserToday 2: ', canLc);
       } else {  //just continue
        //addpoints = pointsToday + pointsAdded;
        const current = Number(pointsToday);
        const added = Number(pointsAdded);

        if (!Number.isFinite(current) || !Number.isFinite(added)) {
          throw new Error("Invalid numeric input");
        }

        const addpoints = current + added;

        updates[`/user/${userUid}/pointsToday`] = addpoints;
        // console.log('freshcardLog canAwardUserToday 3: ', canLc);
        // console.log('freshcardLog canAwardUserToday 3a: ', pointsToday);
        // console.log('freshcardLog canAwardUserToday 3b: ', pointsAdded);
        // console.log('freshcardLog canAwardUserToday 3c: ', addpoints);
        canLc = true;
        }
      } else { //start over
       updates[`/user/${userUid}/lctime`] = newPaddedDate;
       updates[`/user/${userUid}/pointsToday`] = pointsAdded;  
      // console.log('freshcardLog canAwardUserToday 4: ', canLc);
       canLc = true;
     }
         console.log('likesPoints 4b: ', LimitIs);
      if ( canLc===true ) {
         console.log('likesPoints 4c: ', updates);

        /////////////////////////////////////////////////////////////////////////////////
         var res = await axios.post(`${FB_URL}/m121-freshpoints`, {
                params: {
                    updates: updates, //user wallet address 
                    deploycode: '4046'//process.env.REACT_APP_DEPLOYMENTCODE                      
                }
          })
      if (res.data || res.data.success === true) {
        console.log('freshcardLog canAwardUserToday success')
      }
      else{
        console.log('freshcardLog canAwardUserToday fail')
      }
      //////////////////////////////////////////////////////////////////////////////// 
    }  
     console.log('likesPoints 4d: ', canLc);
   return canLc;
 }

function safeParseFloat(value, fallback = 0) {
    if (value == null) return fallback;
    
    // Remove whitespace
    const str = String(value).trim();
    
    // Only allow proper number format
    if (!/^[-+]?(?:\d*\.)?\d+$/.test(str)) {
        console.warn(`Invalid number format rejected: "${str}"`);
        return fallback;
    }
    
    const num = parseFloat(str);
    
    // Optional: reject NaN / Infinity
    if (!Number.isFinite(num)) {
        return fallback;
    }
    
    return num;
}

function continueTransaction(LimitIs, currentToday, newLCtoday, addedb) {
    // If currentToday is already above the limit → no restriction
    if (currentToday > LimitIs) {
        return true;  // allow any value
    }

    // Normal case: enforce |newLCtoday - currentToday| ≤ |addedb|
    const diff = newLCtoday - currentToday;
    const maxAllowedChange = Math.abs(addedb);

    // Case 1: trying to increase too much
    if (diff > maxAllowedChange) {
        // cap the increase at +|addedb|
        return false;//currentToday + maxAllowedChange;
    }

    // Case 2: trying to decrease too much
    if (diff < -maxAllowedChange) {
        // cap the decrease at -|addedb|
        return false;//currentToday - maxAllowedChange;
    }

    // Within allowed range → accept as is
    return true;//newLCtoday;
}

export const likesPoints = params => {
  return async (dispatch, getState) => {
    try {
      console.log('likesPoints 1: ', params);

      // Get current user's ID token for auth
      const user = await firebase.auth.currentUser;
      if (!user) {
        throw new Error('User not authenticated');
      }
      const idToken = await user.getIdToken();

      if (!user) throw new Error("Not signed in");
      const logged_uid = user.uid;

      const pointsLim = getDailyUserLimitLc();

      console.log('freshcard likesPoints: ', pointsLim);

      // Send minimal data to server
      const res = await axios.post(`${FB_URL}/m121-freshpoints`, {
        params: {
          ...params,  // Include userID, pointsAdded, trailID, companyName, firstName, lastName, title, actionType, actionDesc, etc.
          deploycode: '4046',
          pointsLim: pointsLim,
          logged_uid: logged_uid
        },
        idToken  // Send token separately
      });

      /** -------------------------------
       *     CHECK BACKEND SUCCESS
       *--------------------------------*/
      if (res.data.success === true) {
        // Record earnings client-side if needed, but ideally move this to server too
        const newPaddedDate = res.data.newPaddedDate;  // Server can return this if you need it
        recordUserDailyEarnings(params.userID, params.pointsAdded, newPaddedDate);

        const pointsNote = params.currentUser === params.userID
          ? ' Lc added to your points.'
          : ' Lc added to ' + params.firstName;

        dispatch({
          type: SHOW_TOAST,
          variant: 'success',
          message: params.pointsAdded > 0
            ? (params.pointsAdded / 100).toFixed(3) + pointsNote
            : 'Lc adjusted ' + (params.pointsAdded / 100).toFixed(3) + ' Lc subtracted',
          pos: 'bottom'
        });
      } else {
        dispatch({
          type: SHOW_TOAST,
          open: true,
          variant: 'info',
          message: res.data.error || 'Failed to update database',
          pos: 'bottom'
        });
      }
    } catch (error) {
      console.error('likesPoints error:', error);
      dispatch({
        type: SHOW_TOAST,
        open: true,
        variant: 'error',
        message: 'An error occurred: ' + error.message
      });
    }
  };
};

export const addMorePoints = (params) => {
  return async (dispatch, getState) => {
    try {
      console.log('addMorePoints 1: ', params);

      const user = await firebase.auth.currentUser;
      
      if (!user) {
        throw new Error('User not authenticated');
      }
      const idToken = await user.getIdToken();
      if (!user) throw new Error("Not signed in");
      const logged_uid = user.uid;

      console.log('addMorePoints 2: ', params);

      const pointsLim = getDailyUserLimitLc();
      // Optional: client-side early check for zero/negative addition (optional optimization)
      const pointsAddedNum = Number(params.pointsAdded || 0);
      if (pointsAddedNum === 0) {
        dispatch({
          type: SHOW_TOAST,
          variant: 'info',
          message: 'No points to add.',
          pos: 'bottom',
        });
        return;
      }
      console.log('addMorePoints 3: ', params);
      // Send minimal data — server will do everything else
      const res = await axios.post(`${FB_URL}/m121-freshpoints`, {
        params: {
          ...params,                 // userID, uid, pointsAdded, trailID, companyName, firstName, lastName, title, actionType, actionDesc, leadPoints?, forceAward?, etc.
          deploycode: '4046',
          pointsLim: pointsLim,
          logged_uid: logged_uid
          // Do NOT send: pointsCurrent, ypointsCurrent, updates, dates, etc.
        },
        idToken,
      });
      console.log('addMorePoints 4: ', params);
      if (res.data.success === true) {
        // Server handled the award — record locally if needed
        const newPaddedDate = res.data.newPaddedDate; // returned from server
        recordUserDailyEarnings(params.userID, pointsAddedNum, newPaddedDate);

        const pointsNote =
          params.currentUser === params.userID
            ? ' Lc added to your points.'
            : ' Lc added to ' + params.firstName;

        dispatch({
          type: SHOW_TOAST,
          variant: 'success',
          message:
            pointsAddedNum > 0
              ? `${(pointsAddedNum / 100).toFixed(3)}${pointsNote}`
              : `Lc adjusted ${(Math.abs(pointsAddedNum) / 100).toFixed(3)} Lc subtracted`,
          pos: 'bottom',
        });
      } else {
        // Server decided not to award (limit reached, invalid, etc.)
        dispatch({
          type: SHOW_TOAST,
          open: true,
          variant: 'info', // or 'warning'
          message: res.data.error || 'No Lc awarded. Daily limit reached — try again tomorrow.',
          pos: 'bottom',
        });
      }
    } catch (error) {
      console.error('addMorePoints error:', error);
      dispatch({
        type: SHOW_TOAST,
        open: true,
        variant: 'error',
        message: 'Failed to award points: ' + (error.message || 'Unknown error'),
      });
    }
  };
};

 export const likesPoints_default = params => {
  return async (dispatch, getState) => {
    try {
      var stoptoday = false;
      console.log('likesPoints 1: ', params);

      var LimitIs = await limitIs();
      // Allow deductions (e.g., unlike) even if quota reached
     // if (Number(params.pointsAdded) < 0) { passL = true; }

    console.log('likesPoints 2: ', LimitIs);

      let database = firebase.database
      let parleadPoints
    if (params.leadPoints) {
      // its ok
      parleadPoints = params.leadPoints
    } else {
      parleadPoints = 0
    }
  
    if (params.pointsCurrent) {
      if (params.pointsAdded > 0) {
        var totPoints = safeParseFloat(params.pointsCurrent) + safeParseFloat(params.pointsAdded)
        var leadPoints = safeParseFloat(parleadPoints) + safeParseFloat(params.pointsAdded)
      } else {
        var totPoints = safeParseFloat(params.pointsCurrent) - safeParseFloat(Math.abs(params.pointsAdded))
        var leadPoints = safeParseFloat(parleadPoints) - safeParseFloat(Math.abs(params.pointsAdded))
      }
    } else {
      totPoints = 0
    }
    if (params.ypointsCurrent!==undefined) {
      var ytotPoints = safeParseFloat(params.ypointsCurrent) + safeParseFloat(params.pointsAdded)
    } else {
      ytotPoints = 0
    }
  
    if (totPoints < 0) {
      totPoints = 0
    }
    if (ytotPoints < 0) {
      ytotPoints = 0
    }
    const updates = {}
    var totLc = totPoints / 100;

    var totSlc = totLc.toString()

      // /////////////////////////////////////////////////////////////////////////
      // const timeRaw = moment().tz('Africa/Johannesburg'); // Set timezone to SAST
      // const year = timeRaw.format('YYYY');
      // const month = timeRaw.format('MM'); // 2-digit month
      // const day = timeRaw.format('DD'); // 2-digit day
      // const hours = timeRaw.format('HH'); // 2-digit hours
      // const minutes = timeRaw.format('mm'); // 2-digit minutes

      //const fdate = `${year}-${month}-${day} ${hours}:${minutes}`;
       // Example output: "2024-11-06 08:45"
      ////////////////////////////////////////////////////////////////////////////
    var doQuery = false;
    var q = 0;
    var QueryContent = [];
    var arrayLength;
  
    let pointsNote = ''
  
    if (params.currentUser === params.userID) { // Points made by LEAD owner
      pointsNote = ' Lc added to your points.'
    } else { // Points made by other users comment on LEAD
      pointsNote = ' Lc added to ' + params.firstName
    }
    if (totPoints) {
      let r = 0
      let kk; let ds; let nn; let xx; let restmm; let snapshotKidz
      let leadUpdate = []
      console.log('likesPoints 3: ', totPoints);

        updates['/user/' + params.uid + '/points'] = totPoints
        updates['/users/' + params.userID + '/points'] = totPoints
        updates['/user/' + params.uid + '/pointsy'] = ytotPoints
        updates['/users/' + params.userID + '/pointsy'] = ytotPoints
         
          ////////UPDATE LCPOOL////////////////////////////////////////////////////
          // const db = firebase.database;
          // const offsetRef = db.ref('.info/serverTimeOffset');
          // const snapp = await offsetRef.once('value');
          // const offset = snapp.val() || 0;
          // const timeNow = new Date(Date.now() + offset);
          
          // const dateObj = timeNow;
          // const month   = dateObj.getUTCMonth() + 1; // months from 1-12
          // const day     = dateObj.getUTCDate();
          // const year    = dateObj.getUTCFullYear();
  
          // //const newDate = year + "/" + month + "/" + day;
  
          // const newDate = `${year}/${month}/${day}`;
  
          // // Using padded values, so that 2023/1/7 becomes 2023/01/07
          // const pMonth        = month.toString().padStart(2,"0");
          // const pDay          = day.toString().padStart(2,"0");
          // const newPaddedDate = `${year}/${pMonth}/${pDay}`;
        //////////////////////////////////////////////////////////////
      // const db = firebase.database;
      // const offsetRef = db.ref('.info/serverTimeOffset');

      // const snapp = await offsetRef.once('value');
      // const offset = snapp.val() || 0;

      // // Get server-adjusted time (same logic as moment().tz('Africa/Johannesburg') would use)
      // const timeNow = new Date(Date.now() + offset);

      // // Extract components using UTC methods (Firebase offset gives Johannesburg-local time)
      // const year  = timeNow.getUTCFullYear();
      // const month = timeNow.getUTCMonth() + 1;     // 1–12
      // const day   = timeNow.getUTCDate();

      // const hour   = timeNow.getUTCHours();
      // const minute = timeNow.getUTCMinutes();

      // // Format exactly like your first example: YYYY-MM-DD HH:mm
      // const fdate = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')} `
      //             + `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;

      // // If you also want the padded slash version (like newPaddedDate), you can keep/add:
      // const pMonth = month.toString().padStart(2, '0');
      // const pDay   = day.toString().padStart(2, '0');
      // const newPaddedDate = `${year}/${pMonth}/${pDay}`;   // still available if needed
      const timeRaw = moment().tz('Africa/Johannesburg');

      const fdate = timeRaw.format('YYYY-MM-DD HH:mm');          // e.g. 2026-02-12 16:45
      const newPaddedDate = timeRaw.format('YYYY/MM/DD');        // e.g. 2026/02/12  
      ////////////////////////////////////////////////////////////////////////////////////
      //const fakedate = "2026/02/11"
      console.log('likesPoints 4: ', params.pointsAdded);
      var passL = await canAwardUserToday(params.uid, params.pointsAdded, newPaddedDate);
      console.log('likesPoints 5: ', passL);
      ///////////////////////////////////////////////////////////////////////////////////// 
      const snap = await database.ref('patreon').once('value');
      const data = snap.val() || {};

      // ── Parse safely ─────────────────────────────────
      const currentPool   = Number(data.LCPOOL)   || 0;
      const currentToday  = Number(data.LCtoday)  || 0;
      const addPoints     = Number(params.pointsAdded) || 0;

      console.log('likesPoints 6: ', addPoints);
      // if (addPoints <= 0) {
      //   // nothing to do — or throw / return early depending on your needs
      //   return { LCtoday: currentToday, LCPOOL: currentPool, Datetoday: data.Datetoday || newPaddedDate };
      // }

      // ── Decide logic ─────────────────────────────────
      const storedDate = data.Datetoday || '';           // missing = treat as new day
      const isSameDay  = storedDate === newPaddedDate;

      const pointsToAward = addPoints;//Math.min(addPoints, currentPool);   // prevent negative pool

      // let newLCtoday;
      // if (isSameDay) {
      //   newLCtoday = currentToday + pointsToAward;
      // } else {
      //   newLCtoday = pointsToAward;   // reset + add today's portion
      // }
      console.log('likesPoints 7: ', pointsToAward);

     // console.log('likesPoints stoptoday true/false: ', currentToday + ' - ' + LimitIs);
      let newLCtoday;
      if (isSameDay) {
       if (currentToday > LimitIs) { 
          newLCtoday = currentToday;  // pause basically
          stoptoday = true;
          console.log('likesPoints stoptoday = true');
       } else {
        const current = Number(currentToday);
        const added = Number(pointsToAward);

        if (!Number.isFinite(current) || !Number.isFinite(added)) {
          throw new Error("Invalid numeric input");
        }
        newLCtoday = current + added; 
        console.log('likesPoints 8a: ', current + '   ' + added);  
        console.log('likesPoints 8b: ', newLCtoday);

        //newLCtoday = currentToday + pointsToAward; // advance - most common outcome
        }
      } else {
        newLCtoday = pointsToAward;   // reset + add today's portion
      }
      ///////////////////////////////////////////////////////
       const currentb = Number(currentPool);
       const addedb = Number(pointsToAward);

        if (!Number.isFinite(currentb) || !Number.isFinite(addedb)) {
          throw new Error("Invalid numeric input");
        }
       // newLCtoday = current + added;   
      const newLCPOOL    = currentb - addedb;
      const newDatetoday = newPaddedDate;   // will be written either way (common & simple)
      console.log('likesPoints 9a: ', currentb + '  ' + addedb);  
      console.log('likesPoints 9b: ', newLCPOOL);

      // ── Prepare the three updates only ───────────────
      // These are ready to be used in your atomic update later
      
      //currentToday   newLCtoday  addedb
      const continueIt = continueTransaction((LimitIs, currentToday, newLCtoday, addedb))
   
      console.log('likesPoints 9c: ', continueIt);
   
      if (continueIt===false) { 
        stoptoday = true; //
      }
      updates['/patreon/LCtoday'] = newLCtoday;
      updates['/patreon/LCPOOL']  = newLCPOOL;
      updates['/patreon/Datetoday'] = newDatetoday;   // ← always write the clean version
    
    /////////////////////////////////////////////////////////////////////////////////////// 
    // if (passL===false)  { //over daily limit
    //   updatesP['/patreon/LCtoday'] = newLCtoday;
    //   updatesP['/patreon/Datetoday'] = newDatetoday; 
    //     var res = await axios.post(`${FB_URL}/m115-freshcard`, {
    //         params: {
    //             updates: updatesP, //user wallet address                       
    //         }
    //     })
    //   if (res.data || res.data.success === true) {     
    //      console.log('update L');
    //     }
    //     else
    //     {
    //      console.log('');
    //     }
    //     dispatch({
    //       type: SHOW_TOAST,
    //       open: true,
    //       variant: 'success',
    //       message: 'Daily LC limit reached for today. Please continue tomorrow. Thank you.'
    //     }); 
    //   }
    /////////////////////////////////////////////////////////////////////////////////
        const pts = (Number(params.pointsAdded) / 100);
        const ptsA = pts;//.toString() 
        const ptsB = ptsA;// + ' Lc'

        const cpts = (Number(totPoints) / 100);
        const cptsA = cpts//.toFixed(3);
        const cptsB = cptsA;//.toString() 
        const cptsC = cptsB;// + ' Lc'

        console.log('likesPoints fdate 1: ', fdate);
        console.log('likesPoints fdate 2: ', newPaddedDate);

        updates['/pointsTrail/' + params.trailID] = {
          userID: params.userID,
          fdate: fdate,
          trailID: params.trailID,
          companyName: params.companyName,
          firstName: params.firstName,
          lastName: params.lastName,
          title: params.title,
          actionType: params.actionType,
          actionDesc: params.actionDesc,
          pointsAdded: ptsB,
          pointsCurrent: cptsC,
          gas: 0
        }
  
        updates['/MEVDATA/' + params.trailID] = {
          userID: params.userID,
          fdate: fdate,
          trailID: params.trailID,
          companyName: params.companyName,
          firstName: params.firstName,
          lastName: params.lastName,
          title: params.title,
          actionType: params.actionType,
          actionDesc: params.actionDesc,
          pointsAdded: ptsB,
          pointsCurrent: cptsC,
          gas: 0
        }

        //  await database
        //   .ref()
        //   .update(updates)
        //   .then(() => {
        //     // Update per-user daily earnings aggregate
        //     recordUserDailyEarnings(params.userID, params.pointsAdded);
        //     dispatch({
        //       type: SHOW_TOAST,
        //       variant: 'success',
        //       message:
        //         params.pointsAdded > 0
        //           ? ((params.pointsAdded)/100).toFixed(3) + pointsNote
        //           : 'Lc adjusted ' +
        //           ((params.pointsAdded)/100).toFixed(3) +
        //           ' Lc subtracted',
        //       pos: 'bottom'
        //     })
        //   })

     if (passL===false) {
      stoptoday = true;
     }
    // stoptoday = true;
     if (stoptoday===false) {
      console.log('likesPoints 10: ', updates);
     // update Lc on back end
          var res = await axios.post(`${FB_URL}/m121-freshpoints`, {
                params: {
                    updates: updates, //user wallet address 
                    deploycode: '403'//process.env.REACT_APP_DEPLOYMENTCODE                      
                }
          })
      /** -------------------------------
       *     CHECK BACKEND SUCCESS
       *--------------------------------*/
      if (res.data || res.data.success === true) {
      // NOW (and only now) record earnings and show main toast
      recordUserDailyEarnings(params.userID, params.pointsAdded, newPaddedDate);// ← only once, here
      const pointsNote =
        params.currentUser === params.userID
          ? ' Lc added to your points.'
          : ' Lc added to ' + params.firstName;

      dispatch({
          type: SHOW_TOAST,
          variant: 'success',
          message:
            params.pointsAdded > 0
              ? ((params.pointsAdded)/100).toFixed(3) + pointsNote
              : 'Lc adjusted ' +
              ((params.pointsAdded)/100).toFixed(3) +
              ' Lc subtracted',
          pos: 'bottom'
      });
    } else {
      console.error('likesPoints error:', error);
      dispatch({
        type: SHOW_TOAST,
        open: true,
        variant: 'error',
        message: 'Failed update database',
      });
    }
  }
   else
   {
       dispatch({
        type: SHOW_TOAST,
        open: true,
        variant: 'success',
        message: 'No Lc awarded. Daily Limit for Lc has been reached. Lc will be awarded tomorrow again.',
      });   
   }
    }

 } catch (error) {
 
 // Handle the error appropriately
 dispatch({
   type: SHOW_TOAST,
   open: true,
   variant: 'error',
   message: 'An error occurred while checking LC quota 1:' + error
 });
 }
 }; 
   }

 export const addMorePoints_default = (params) => {
  return async (dispatch, getState) => {
    try {
       var stoptoday = false;
      const pointsAddedNum = Number(params.pointsAdded || 0);

      var LimitIs = await limitIs();

     console.log('addMorePoints 1: ', params);
      // Basic setup
      const parleadPoints = params.leadPoints ? Number(params.leadPoints) : 0;
      const database = firebase.database; // keep as you had it
      let totPoints = 0;
      let ytotPoints = 0;
      let leadPoints = 0;

      // If forced award, read current values from database first
      // Then backend will handle the actual writes via transaction
      if (params && params.forceAward === true) {
        const inc = safeParseFloat(pointsAddedNum || 0);

        const userPtsRef = database.ref('/user/' + params.uid + '/points');
        const userYPtsRef = database.ref('/user/' + params.uid + '/pointsy');

        // Read current values (no writes here - backend will handle via transaction)
        const currentPtsSnap = await userPtsRef.once('value');
        const currentYPtsSnap = await userYPtsRef.once('value');

        const currentPoints = safeParseFloat(currentPtsSnap.val() || 0);
        const currentYPoints = safeParseFloat(currentYPtsSnap.val() || 0);

        // Calculate new values
        totPoints = currentPoints + inc;
        ytotPoints = currentYPoints + inc;
        leadPoints = parleadPoints + inc;
      } else {
        // Non-force: calculate from provided params (fall back to 0 if missing)
        totPoints = safeParseFloat(params.pointsCurrent || 0) + pointsAddedNum;
        ytotPoints = safeParseFloat(params.ypointsCurrent || 0) + pointsAddedNum;
        leadPoints = parleadPoints + pointsAddedNum;
      }

      // The original code then forced ytotPoints based on params.ypointsCurrent presence.
      // Preserve that behavior but write it clearly:
      if (params.ypointsCurrent !== undefined) {
        ytotPoints = safeParseFloat(params.ypointsCurrent || 0) + pointsAddedNum;
      } else {
        // original set to 0 when undefined
        ytotPoints = 0;
      }

      // Ensure no negatives
      if (totPoints < 0) totPoints = 0;
      if (ytotPoints < 0) ytotPoints = 0;

      // Prepare updates
      const updates = {};

      // Always include user points in updates object - backend will handle the write
      // (removed the forceAward check since backend needs to know what to update)
      updates['/user/' + params.uid + '/points'] = totPoints;
      updates['/users/' + params.userID + '/points'] = totPoints;
      updates['/user/' + params.uid + '/pointsy'] = ytotPoints;
      updates['/users/' + params.userID + '/pointsy'] = ytotPoints;

      // const db = firebase.database;
      // const offsetRef = db.ref('.info/serverTimeOffset');
      // const snapp = await offsetRef.once('value');
      // const offset = snapp.val() || 0;
      // const timeNow = new Date(Date.now() + offset);
      
      // const dateObj = timeNow;
      // const month = dateObj.getUTCMonth() + 1; // 1-12
      // const day = dateObj.getUTCDate();
      // const year = dateObj.getUTCFullYear();

      // const newDate = `${year}/${month}/${day}`;
      // const pMonth = month.toString().padStart(2, '0');
      // const pDay = day.toString().padStart(2, '0');
      // const newPaddedDate = `${year}/${pMonth}/${pDay}`;
      ///////////////////////////////////////////////////////////////////////////////////
      // const db = firebase.database;
      // const offsetRef = db.ref('.info/serverTimeOffset');

      // const snapp = await offsetRef.once('value');
      // const offset = snapp.val() || 0;

      // // Get server-adjusted time (same logic as moment().tz('Africa/Johannesburg') would use)
      // const timeNow = new Date(Date.now() + offset);

      // // Extract components using UTC methods (Firebase offset gives Johannesburg-local time)
      // const year  = timeNow.getUTCFullYear();
      // const month = timeNow.getUTCMonth() + 1;     // 1–12
      // const day   = timeNow.getUTCDate();

      // const hour   = timeNow.getUTCHours();
      // const minute = timeNow.getUTCMinutes();

      // // Format exactly like your first example: YYYY-MM-DD HH:mm
      // const fdate = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')} `
      //             + `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;

      // // If you also want the padded slash version (like newPaddedDate), you can keep/add:
      // const pMonth = month.toString().padStart(2, '0');
      // const pDay   = day.toString().padStart(2, '0');
      // const newPaddedDate = `${year}/${pMonth}/${pDay}`;   // still available if needed
      const timeRaw = moment().tz('Africa/Johannesburg');

      const fdate = timeRaw.format('YYYY-MM-DD HH:mm');          // e.g. 2026-02-12 16:45
      const newPaddedDate = timeRaw.format('YYYY/MM/DD'); 
      ////////////////////////////////////////////////////////////////////////////////////
      //const fakedate = "2026/02/11"
      var passL = await canAwardUserToday(params.uid, params.pointsAdded, newPaddedDate);
      console.log('addmorepoints 2: ', passL);
      /////////////////////////////////////////////////////////////////////////////////////      const snap = await database.ref('patreon').once('value');
      const snap = await database.ref('patreon').once('value');
      const data = snap.val() || {};

      // ── Parse safely ─────────────────────────────────
      const currentPool   = Number(data.LCPOOL)   || 0;
      const currentToday  = Number(data.LCtoday)  || 0;
      const addPoints     = Number(params.pointsAdded) || 0;

      // if (addPoints <= 0) {
      //   // nothing to do — or throw / return early depending on your needs
      //   return { LCtoday: currentToday, LCPOOL: currentPool, Datetoday: data.Datetoday || newPaddedDate };
      // }

      // ── Decide logic ─────────────────────────────────
      const storedDate = data.Datetoday || '';           // missing = treat as new day
      const isSameDay  = storedDate === newPaddedDate;

      const pointsToAward = addPoints;//Math.min(addPoints, currentPool);   // prevent negative pool

      // let newLCtoday;
      // if (isSameDay) {
      //   newLCtoday = currentToday + pointsToAward;
      // } else {
      //   newLCtoday = pointsToAward;   // reset + add today's portion
      // }

      let newLCtoday;
      if (isSameDay) {
       if (currentToday > LimitIs) { 
          newLCtoday = currentToday;  // pause
          stoptoday = true;
           console.log('addMorePoints stoptoday = true 1')
       } else {
          const current = Number(currentToday);
          const added = Number(pointsToAward);

          if (!Number.isFinite(current) || !Number.isFinite(added)) {
            throw new Error("Invalid numeric input");
          }
          newLCtoday = current + added; 
          console.log('addMorePoints 3a: ', current + '   ' + added);  
          console.log('addMorePoints 3b: ', newLCtoday);

         // newLCtoday = currentToday + pointsToAward; // advance - most common outcome
        }
      } else {
        newLCtoday = pointsToAward;   // reset + add today's portion
      }
       const currentb = Number(currentPool);
       const addedb = Number(pointsToAward);

        if (!Number.isFinite(currentb) || !Number.isFinite(addedb)) {
          throw new Error("Invalid numeric input");
        }
     //const newLCPOOL    = currentPool - pointsToAward;
      const newLCPOOL    = currentb - addedb;
      const newDatetoday = newPaddedDate;   // will be written either way (common & simple)

      // ── Prepare the three updates only ───────────────
      // These are ready to be used in your atomic update later
      const continueIt = continueTransaction((LimitIs, currentToday, newLCtoday, addedb))
      console.log('addMorePoints 3c: ', continueIt);
  
      if (continueIt===false) { 
        stoptoday = true;
      }

      updates['/patreon/LCtoday'] = newLCtoday;
      updates['/patreon/LCPOOL']  = newLCPOOL;
      updates['/patreon/Datetoday'] = newDatetoday;   // ← always write the clean version
    
      // Timestamp for trails (SAST)
      //const timeRaw = moment().tz('Africa/Johannesburg');
      //const fdate = `${timeRaw.format('YYYY')}-${timeRaw.format('MM')}-${timeRaw.format('DD')} ${timeRaw.format('HH')}:${timeRaw.format('mm')}`;

      // Points values preserved as in original (divide by 100)
      const ptsB = Number(pointsAddedNum) / 100;
      const cptsC = Number(totPoints) / 100;

      // Update pointsTrail and MEVDATA
      updates['/pointsTrail/' + params.trailID] = {
        userID: params.userID,
        fdate: fdate,
        trailID: params.trailID,
        companyName: params.companyName,
        firstName: params.firstName,
        lastName: params.lastName,
        title: params.title,
        actionType: params.actionType,
        actionDesc: params.actionDesc,
        pointsAdded: ptsB,
        pointsCurrent: cptsC,
        gas: 0
      };

      updates['/MEVDATA/' + params.trailID] = {
        userID: params.userID,
        fdate: fdate,
        trailID: params.trailID,
        companyName: params.companyName,
        firstName: params.firstName,
        lastName: params.lastName,
        title: params.title,
        actionType: params.actionType,
        actionDesc: params.actionDesc,
        pointsAdded: ptsB,
        pointsCurrent: cptsC,
        gas: 0
      };

      // If totPoints is falsy (0/undefined), original code skipped the update + axios + toast.
      // Preserve that behavior:
      if (!totPoints && totPoints !== 0) {
        // totPoints is undefined/null, bail out safely
        dispatch({
          type: SHOW_TOAST,
          open: true,
          variant: 'error',
          message: 'Unable to compute total points for user.'
        });
        return;
      }
     
     if (passL===false) {
      stoptoday = true;
     }
    // stoptoday = true;
      if (stoptoday===false) {
           console.log('addMorePoints 4: ', params);
          // update Lc on back end
               var res = await axios.post(`${FB_URL}/m121-freshpoints`, {
                      params: {
                          updates: updates, //user wallet address 
                          deploycode: '403'//process.env.REACT_APP_DEPLOYMENTCODE                        
                      }
                })
      /** -------------------------------
       *     CHECK BACKEND SUCCESS
       *--------------------------------*/
      if (res.data || res.data.success === true) {
      // NOW (and only now) record earnings and show main toast
      recordUserDailyEarnings(params.userID, pointsAddedNum, newPaddedDate);  // ← only once, here

      const pointsNote =
        params.currentUser === params.userID
          ? ' Lc added to your points.'
          : ' Lc added to ' + params.firstName;

      dispatch({
        type: SHOW_TOAST,
        open: true,
        variant: 'success',
        message:
          pointsAddedNum > 0
            ? `${pointsAddedNum / 100}${pointsNote}`
            : `Lc adjusted ${Math.abs(pointsAddedNum / 100)} Lc subtracted`,
        pos: 'bottom',
      });
    } else {
      console.error('addMorePoints error:', error);
      dispatch({
        type: SHOW_TOAST,
        open: true,
        variant: 'error',
        message: 'Failed update database',
      });
    }
  }
  else{
    dispatch({
        type: SHOW_TOAST,
        open: true,
        variant: 'success',
        message: 'No Lc awarded. Daily Limit for Lc has been reached. Lc will be awarded tomorrow again.',
      });  
  }
    } catch (error) {
      console.error('addMorePoints error:', error);
      dispatch({
        type: SHOW_TOAST,
        open: true,
        variant: 'error',
        message: 'Failed to award points: ' + (error.message || error),
      });
    }   
  };
  };

//  export const addMorePoints_7Feb2026 = (params) => {
//   return async (dispatch, getState) => {
//     try {
//       // Normalize numeric inputs
//       const pointsAddedNum = Number(params.pointsAdded || 0);

//      // Check quota (allow negative adjustments always)
//      // let passL = await canAwardUserToday(params.userID, pointsAddedNum);
//      // if (pointsAddedNum < 0) passL = true;

//       var passL = await PassLC(); 
//       console.log('PassLC addMorePoints: ', passL);

//       if (!passL) {
//         dispatch({
//           type: SHOW_TOAST,
//           open: true,
//           variant: 'success',
//           message: 'Daily LC limit reached for today. Thank you.'
//         });
//         return;
//       }

//       // Basic setup
//       const parleadPoints = params.leadPoints ? Number(params.leadPoints) : 0;
//       const database = firebase.database; // keep as you had it
//       let totPoints = 0;
//       let ytotPoints = 0;
//       let leadPoints = 0;

//       // If forced award, read current values from database first
//       // Then backend will handle the actual writes via transaction
//       if (params && params.forceAward === true) {
//         const inc = parseFloat(pointsAddedNum || 0);

//         const userPtsRef = database.ref('/user/' + params.uid + '/points');
//         const userYPtsRef = database.ref('/user/' + params.uid + '/pointsy');

//         // Read current values (no writes here - backend will handle via transaction)
//         const currentPtsSnap = await userPtsRef.once('value');
//         const currentYPtsSnap = await userYPtsRef.once('value');

//         const currentPoints = parseFloat(currentPtsSnap.val() || 0);
//         const currentYPoints = parseFloat(currentYPtsSnap.val() || 0);

//         // Calculate new values
//         totPoints = currentPoints + inc;
//         ytotPoints = currentYPoints + inc;
//         leadPoints = parleadPoints + inc;
//       } else {
//         // Non-force: calculate from provided params (fall back to 0 if missing)
//         totPoints = parseFloat(params.pointsCurrent || 0) + pointsAddedNum;
//         ytotPoints = parseFloat(params.ypointsCurrent || 0) + pointsAddedNum;
//         leadPoints = parleadPoints + pointsAddedNum;
//       }

//       // The original code then forced ytotPoints based on params.ypointsCurrent presence.
//       // Preserve that behavior but write it clearly:
//       if (params.ypointsCurrent !== undefined) {
//         ytotPoints = parseFloat(params.ypointsCurrent || 0) + pointsAddedNum;
//       } else {
//         // original set to 0 when undefined
//         ytotPoints = 0;
//       }

//       // Ensure no negatives
//       if (totPoints < 0) totPoints = 0;
//       if (ytotPoints < 0) ytotPoints = 0;

//       // Prepare updates
//       const updates = {};

//       // Always include user points in updates object - backend will handle the write
//       // (removed the forceAward check since backend needs to know what to update)
//       updates['/user/' + params.uid + '/points'] = totPoints;
//       updates['/users/' + params.userID + '/points'] = totPoints;
//       updates['/user/' + params.uid + '/pointsy'] = ytotPoints;
//       updates['/users/' + params.userID + '/pointsy'] = ytotPoints;

//       // Update LCPOOL / patreon fields (preserve original logic)
//       // const dateObj = new Date();
//       // const month = dateObj.getUTCMonth() + 1; // 1-12
//       // const day = dateObj.getUTCDate();
//       // const year = dateObj.getUTCFullYear();

//       // const newDate = `${year}/${month}/${day}`;
//       // const pMonth = month.toString().padStart(2, '0');
//       // const pDay = day.toString().padStart(2, '0');
//       // const newPaddedDate = `${year}/${pMonth}/${pDay}`;
//       const db = firebase.database;
//       const offsetRef = db.ref('.info/serverTimeOffset');
//       const snapp = await offsetRef.once('value');
//       const offset = snapp.val() || 0;
//       const timeNow = new Date(Date.now() + offset);
      
//       const dateObj = timeNow;
//       const month = dateObj.getUTCMonth() + 1; // 1-12
//       const day = dateObj.getUTCDate();
//       const year = dateObj.getUTCFullYear();

//       const newDate = `${year}/${month}/${day}`;
//       const pMonth = month.toString().padStart(2, '0');
//       const pDay = day.toString().padStart(2, '0');
//       const newPaddedDate = `${year}/${pMonth}/${pDay}`;

//       // 1. Get data
//       const snap = await database.ref('patreon').once('value');
//       const data = snap.val() || {};

//       // 2. Parse numbers EARLY – before any use
//       const lcpool    = parseFloat(data.LCPOOL)  || 0;
//       const lctoday   = parseFloat(data.LCtoday) || 0;
//       const addpoints = parseFloat(pointsAddedNum);   // assuming this comes from function param

//       // 3. Now you can safely use them
//       console.log('addMorePoints addpoints: ', addpoints);
//       console.log('addMorePoints LCtoday value to be saved:', 
//         data.Datetoday === newPaddedDate ? lctoday + addpoints : addpoints
//       );

//       // Right after calculating newPaddedDate ...

//       const storedDate = data.Datetoday || '';  // protect against undefined

//       // Decide new value (still using your original comparison logic)
//       const isSameDay = storedDate === newPaddedDate;

//       updates['/patreon/LCtoday'] = isSameDay ? lctoday + addpoints : addpoints;
//       updates['/patreon/LCPOOL']  = lcpool - addpoints;
//       updates['/patreon/Datetoday'] = newPaddedDate;   // ← always write the clean version
            
//       //updates['/patreon/Datetoday'] = newPaddedDate;
//       //updates['/patreon/LCtoday'] = (data.Datetoday === newPaddedDate ? lctoday + addpoints : addpoints);

//       // Timestamp for trails (SAST)
//       const timeRaw = moment().tz('Africa/Johannesburg');
//       const fdate = `${timeRaw.format('YYYY')}-${timeRaw.format('MM')}-${timeRaw.format('DD')} ${timeRaw.format('HH')}:${timeRaw.format('mm')}`;

//       // Points values preserved as in original (divide by 100)
//       const ptsB = Number(pointsAddedNum) / 100;
//       const cptsC = Number(totPoints) / 100;

//       // Update pointsTrail and MEVDATA
//       updates['/pointsTrail/' + params.trailID] = {
//         userID: params.userID,
//         fdate,
//         trailID: params.trailID,
//         companyName: params.companyName,
//         firstName: params.firstName,
//         lastName: params.lastName,
//         title: params.title,
//         actionType: params.actionType,
//         actionDesc: params.actionDesc,
//         pointsAdded: ptsB,
//         pointsCurrent: cptsC,
//         gas: 0
//       };

//       updates['/MEVDATA/' + params.trailID] = {
//         userID: params.userID,
//         fdate,
//         trailID: params.trailID,
//         companyName: params.companyName,
//         firstName: params.firstName,
//         lastName: params.lastName,
//         title: params.title,
//         actionType: params.actionType,
//         actionDesc: params.actionDesc,
//         pointsAdded: ptsB,
//         pointsCurrent: cptsC,
//         gas: 0
//       };

//       // If totPoints is falsy (0/undefined), original code skipped the update + axios + toast.
//       // Preserve that behavior:
//       if (!totPoints && totPoints !== 0) {
//         // totPoints is undefined/null, bail out safely
//         dispatch({
//           type: SHOW_TOAST,
//           open: true,
//           variant: 'error',
//           message: 'Unable to compute total points for user.'
//         });
//         return;
//       }

//           // update Lc on back end
//                var res = await axios.post(`${FB_URL}/m115-freshcard`, {
//                       params: {
//                           updates: updates, //user wallet address                       
//                       }
//                 })
//       /** -------------------------------
//        *     CHECK BACKEND SUCCESS
//        *--------------------------------*/
//       if (res.data || res.data.success === true) {
//       // NOW (and only now) record earnings and show main toast
//       recordUserDailyEarnings(params.userID, pointsAddedNum);  // ← only once, here

//       const pointsNote =
//         params.currentUser === params.userID
//           ? ' Lc added to your points.'
//           : ' Lc added to ' + params.firstName;

//       dispatch({
//         type: SHOW_TOAST,
//         open: true,
//         variant: 'success',
//         message:
//           pointsAddedNum > 0
//             ? `${pointsAddedNum / 100}${pointsNote}`
//             : `Lc adjusted ${Math.abs(pointsAddedNum / 100)} Lc subtracted`,
//         pos: 'bottom',
//       });
//     } else {
//       console.error('addMorePoints error:', error);
//       dispatch({
//         type: SHOW_TOAST,
//         open: true,
//         variant: 'error',
//         message: 'Failed update database',
//       });
//     }

//     } catch (error) {
//       console.error('addMorePoints error:', error);
//       dispatch({
//         type: SHOW_TOAST,
//         open: true,
//         variant: 'error',
//         message: 'Failed to award points: ' + (error.message || error),
//       });
//     }   
//   };
//   };

//  export const likesPoints_default = params => {
//   return async (dispatch, getState) => {
//     try {
//      // var passL = await canAwardUserToday(params.userID, params.pointsAdded);
//       var passL = await PassLC();
//       // Allow deductions (e.g., unlike) even if quota reached
//      // if (Number(params.pointsAdded) < 0) { passL = true; }

//     console.log('PassLC likesPoints: ', passL);

//     if (passL === true) {
//       let database = firebase.database
//       let parleadPoints
//     if (params.leadPoints) {
//       // its ok
//       parleadPoints = params.leadPoints
//     } else {
//       parleadPoints = 0
//     }
  
//     if (params.pointsCurrent) {
//       if (params.pointsAdded > 0) {
//         var totPoints = parseFloat(params.pointsCurrent) + parseFloat(params.pointsAdded)
//         var leadPoints = parseFloat(parleadPoints) + parseFloat(params.pointsAdded)
//       } else {
//         var totPoints = parseFloat(params.pointsCurrent) - parseFloat(Math.abs(params.pointsAdded))
//         var leadPoints = parseFloat(parleadPoints) - parseFloat(Math.abs(params.pointsAdded))
//       }
//     } else {
//       totPoints = 0
//     }
//     if (params.ypointsCurrent!==undefined) {
//       var ytotPoints = parseFloat(params.ypointsCurrent) + parseFloat(params.pointsAdded)
//     } else {
//       ytotPoints = 0
//     }
  
//     if (totPoints < 0) {
//       totPoints = 0
//     }
//     if (ytotPoints < 0) {
//       ytotPoints = 0
//     }
//     const updates = {}
//     var totLc = totPoints / 100;
//     console.log('blacktotLc 1:', totLc);

//     var totSlc = totLc.toString()
//     console.log('blacktotLc 2:', totSlc);

//     // const d = new Date()
//     // const y = d.getFullYear()
//     // const m = d.getMonth()
//     // const day = d.getDate()
//     // const fdate = formatDate(d) // y + '/' + m + '/' + day;
//       // /////////////////////////////////////////////////////////////////////////
//       const timeRaw = moment().tz('Africa/Johannesburg'); // Set timezone to SAST
//       const year = timeRaw.format('YYYY');
//       const month = timeRaw.format('MM'); // 2-digit month
//       const day = timeRaw.format('DD'); // 2-digit day
//       const hours = timeRaw.format('HH'); // 2-digit hours
//       const minutes = timeRaw.format('mm'); // 2-digit minutes

//       const fdate = `${year}-${month}-${day} ${hours}:${minutes}`;
//        // Example output: "2024-11-06 08:45"
//       ////////////////////////////////////////////////////////////////////////////
//     var doQuery = false;
//     var q = 0;
//     var QueryContent = [];
//     var arrayLength;
  
//     let pointsNote = ''
  
//     if (params.currentUser === params.userID) { // Points made by LEAD owner
//       pointsNote = ' Lc added to your points.'
//     } else { // Points made by other users comment on LEAD
//       pointsNote = ' Lc added to ' + params.firstName
//     }
//     if (totPoints) {
//       let r = 0
//       let kk; let ds; let nn; let xx; let restmm; let snapshotKidz
//       let leadUpdate = []
  
//       //   return async (dispatch, getState) => {
//         updates['/user/' + params.uid + '/points'] = totPoints
//         updates['/users/' + params.userID + '/points'] = totPoints
//         updates['/user/' + params.uid + '/pointsy'] = ytotPoints
//         updates['/users/' + params.userID + '/pointsy'] = ytotPoints
         
//         /////////////////////////////////////////////////////////////////////////////
//         // if (params.actionDesc === 'LEAD comment') { //RENDER ALL FORUMS EXCEPT GROUP/S
//         //   database.ref('dailyThoughts').child(params.leadID).update({ leadPoints: leadPoints })
//         //   //database.ref('dailyThoughts').child(params.leadID).update({ points: totPoints })
          
//         //   // UPDATE ALL LEADS (OR TOP 10) FOR THIS USER
//         //   let postRef = database.ref('dailyThoughts').orderByChild('journalUserID').equalTo(params.userID)
//         //   // postRef.on("value", function (snapshot) {
//         //   postRef.once('value')
//         //     .then(async snapshot => {
//         //       snapshot.forEach(function (subChild) {
//         //     //  for( const subChild of snapshot ){
//         //         //const value = snapshot.val()
  
//         //         // for (var i in snapshot.docs) {
//         //         //   const subChild = snapshot.docs[i]
  
//         //         snapshotKidz = snapshot.numChildren();
  
//         //         if (snapshotKidz > 50) {
//         //           xx = snapshotKidz - 50
//         //           if (xx > 50) {
//         //             nn = 50
//         //           }
//         //           if (xx < 50) {
//         //             nn = snapshotKidz - 50
//         //           }
//         //           restmm = snapshotKidz - nn
//         //         } else {
//         //           restmm = 0
//         //         }
//         //         if (r => restmm) {
//         //           // leadUpdate.push(subChild.val().dailyThoughtID);
  
//         //           // leadUpdate.push({"a": subChild.val().dailyThoughtID});
  
//         //           // database.ref('dailyThoughts').child(subChild.val().dailyThoughtID).update({ points: totPoints })
  
//         //           // database.ref('dailyThoughts').child(subChild.val().dailyThoughtID).update({ points: totPoints })
  
//         //           //  database.ref('dailyThoughts').child(subChild.val().dailyThoughtID).update({ points: totPoints })
  
//         //           // database.ref("dailyThoughts").child(subChild.val().dailyThoughtID).update({"leadPoints" : leadPoints});
//         //           // updates['/dailyThoughts/' + subChild.val().dailyThoughtID + '/points'] = totPoints;
//         //           q = q + 1;
//         //           QueryContent.push('/dailyThoughts/' + subChild.val().dailyThoughtID + '/points');
//         //           //GROUP POSTS
//         //           ///group-posts/-LmFFPvjY8Y118CkUgqV/-OIVfTmIqZKsyI_5xw-N
//         //           //group-posts/{groupid}/{postID}
//         //         }
//         //         r = r + 1
//         //       }
  
//         //       )
//         //       ///////////////////////////////////////////////
  
//         //       arrayLength = QueryContent.length;
        
//         //       for (var i = 0; i < arrayLength; i++) {
//         //         updates[QueryContent[i]] = totPoints;
//         //       }
  
//         //       await database
//         //       .ref()
//         //       .update(updates)
//         //       .then(() => {
//         //         dispatch({
//         //           type: SHOW_TOAST,
//         //           variant: 'success',
//         //           message: params.pointsAdded > 0 ? (params.pointsAdded)/100 + pointsNote :
//         //             'Lc adjusted - 1',
//         //           pos: 'bottom'
//         //         })
//         //       })
//         //       .catch(err => {
//         //         dispatch({
//         //           type: 'SHOW_TOAST',
//         //           open: true,
//         //           variant: 'error',
//         //           message: 'Error response: ' + err.message
//         //         })
//         //       })
  
//         //       ////////////////////////////////////////////////
//         //     }
              
//         //     )
//         // }
  
//         // if (params.actionDesc === 'LEAD comment' && params.groupid!='') { //RENDER GROUP
//         //  //GROUP POSTS
//         //  //group-posts/-LmFFPvjY8Y118CkUgqV/-OIVfTmIqZKsyI_5xw-N
//         //  //group-posts/{groupid}/{postID}
//         //   const groupRef = 'group-posts/' + params.groupid

//         //   database.ref(groupRef).child(params.leadID).update({ leadPoints: leadPoints })
//         //   //database.ref('dailyThoughts').child(params.leadID).update({ points: totPoints })
          
//         //   // UPDATE ALL LEADS (OR TOP 10) FOR THIS USER
//         //   let postRef = database.ref(groupRef).orderByChild('journalUserID').equalTo(params.userID)
//         //   // postRef.on("value", function (snapshot) {
//         //   postRef.once('value')
//         //     .then(async snapshot => {
//         //       snapshot.forEach(function (subChild) {
//         //     //  for( const subChild of snapshot ){
//         //         //const value = snapshot.val()
  
//         //         // for (var i in snapshot.docs) {
//         //         //   const subChild = snapshot.docs[i]
  
//         //         snapshotKidz = snapshot.numChildren();
  
//         //         if (snapshotKidz > 50) {
//         //           xx = snapshotKidz - 50
//         //           if (xx > 50) {
//         //             nn = 50
//         //           }
//         //           if (xx < 50) {
//         //             nn = snapshotKidz - 50
//         //           }
//         //           restmm = snapshotKidz - nn
//         //         } else {
//         //           restmm = 0
//         //         }
//         //         if (r => restmm) {
//         //           // leadUpdate.push(subChild.val().dailyThoughtID);
  
//         //           // leadUpdate.push({"a": subChild.val().dailyThoughtID});
  
//         //           // database.ref('dailyThoughts').child(subChild.val().dailyThoughtID).update({ points: totPoints })
  
//         //           // database.ref('dailyThoughts').child(subChild.val().dailyThoughtID).update({ points: totPoints })
  
//         //           //  database.ref('dailyThoughts').child(subChild.val().dailyThoughtID).update({ points: totPoints })
  
//         //           // database.ref("dailyThoughts").child(subChild.val().dailyThoughtID).update({"leadPoints" : leadPoints});
//         //           // updates['/dailyThoughts/' + subChild.val().dailyThoughtID + '/points'] = totPoints;
//         //           q = q + 1;
//         //           QueryContent.push(groupRef + '/' + subChild.val().dailyThoughtID + '/points');
//         //           //GROUP POSTS
//         //           ///group-posts/-LmFFPvjY8Y118CkUgqV/-OIVfTmIqZKsyI_5xw-N
//         //           //group-posts/{groupid}/{postID}
//         //         }
//         //         r = r + 1
//         //       })
  
//         //       )
//         //       ///////////////////////////////////////////////
  
//         //       arrayLength = QueryContent.length;
        
//         //       for (var i = 0; i < arrayLength; i++) {
//         //         updates[QueryContent[i]] = totPoints;
//         //       }
  
//         //       await database
//         //       .ref()
//         //       .update(updates)
//         //       .then(() => {
//         //         dispatch({
//         //           type: SHOW_TOAST,
//         //           variant: 'success',
//         //           message: params.pointsAdded > 0 ? (params.pointsAdded)/100 + pointsNote :
//         //             'Lc adjusted - 1',
//         //           pos: 'bottom'
//         //         })
//         //       })
//         //       .catch(err => {
//         //         dispatch({
//         //           type: 'SHOW_TOAST',
//         //           open: true,
//         //           variant: 'error',
//         //           message: 'Error response: ' + err.message
//         //         })
//         //       })
  
//         //       ////////////////////////////////////////////////
//         //     }
              
//         //     )
//         // }
//           ////////////////////////////////////////////////////////////////////////////

//           ////////UPDATE LCPOOL////////////////////////////////////////////////////
//           const db = firebase.database;
//           const offsetRef = db.ref('.info/serverTimeOffset');
//           const snapp = await offsetRef.once('value');
//           const offset = snapp.val() || 0;
//           const timeNow = new Date(Date.now() + offset);
          
//           const dateObj = timeNow;
//           const month   = dateObj.getUTCMonth() + 1; // months from 1-12
//           const day     = dateObj.getUTCDate();
//           const year    = dateObj.getUTCFullYear();
  
//           //const newDate = year + "/" + month + "/" + day;
  
//           const newDate = `${year}/${month}/${day}`;
  
//           // Using padded values, so that 2023/1/7 becomes 2023/01/07
//           const pMonth        = month.toString().padStart(2,"0");
//           const pDay          = day.toString().padStart(2,"0");
//           const newPaddedDate = `${year}/${pMonth}/${pDay}`;
//           ////////////////////////////////////////////////////////////////////////////////

//       // const snap = await database.ref('patreon').once('value');
//       // const data = snap.val() || {};

//       // // 2. Parse numbers EARLY – before any use
//       // const lcpool    = parseFloat(data.LCPOOL)  || 0;
//       // const lctoday   = parseFloat(data.LCtoday) || 0;
//       // const addpoints = parseFloat(params.pointsAdded);   // assuming this comes from function param

//       // // 3. Now you can safely use them
//       // console.log('likesPoints addpoints: ', addpoints);
//       // console.log('likesPoints LCtoday value to be saved:', 
//       //   data.Datetoday === newPaddedDate ? lctoday + addpoints : addpoints
//       // );

//       // // Right after calculating newPaddedDate ...

//       // const storedDate = data.Datetoday || '';  // protect against undefined

//       // // Decide new value (still using your original comparison logic)
//       // const isSameDay = storedDate === newPaddedDate;
//       //updates['/patreon/LCtoday'] = isSameDay ? lctoday + addpoints : addpoints;
//       //updates['/patreon/LCPOOL']  = lcpool - addpoints;
//       //updates['/patreon/Datetoday'] = newPaddedDate;   // ← always write the clean version
//       ///////////////////////////////////////////////////////////////////////////////////// 
//       const snap = await database.ref('patreon').once('value');
//       const data = snap.val() || {};

//       // ── Parse safely ─────────────────────────────────
//       const currentPool   = Number(data.LCPOOL)   || 0;
//       const currentToday  = Number(data.LCtoday)  || 0;
//       const addPoints     = Number(params.pointsAdded) || 0;

//       if (addPoints <= 0) {
//         // nothing to do — or throw / return early depending on your needs
//         return { LCtoday: currentToday, LCPOOL: currentPool, Datetoday: data.Datetoday || newPaddedDate };
//       }

//       // ── Decide logic ─────────────────────────────────
//       const storedDate = data.Datetoday || '';           // missing = treat as new day
//       const isSameDay  = storedDate === newPaddedDate;

//       const pointsToAward = Math.min(addPoints, currentPool);   // prevent negative pool

//       let newLCtoday;
//       if (isSameDay) {
//         newLCtoday = currentToday + pointsToAward;
//       } else {
//         newLCtoday = pointsToAward;   // reset + add today's portion
//       }

//       const newLCPOOL    = currentPool - pointsToAward;
//       const newDatetoday = newPaddedDate;   // will be written either way (common & simple)

//       // ── Prepare the three updates only ───────────────
//       // These are ready to be used in your atomic update later
      
//       var updatesP = {};

//       updatesP['/patreon/LCtoday'] = newLCtoday;
//       updatesP['/patreon/LCPOOL']  = newLCPOOL;
//       updatesP['/patreon/Datetoday'] = newDatetoday;   // ← always write the clean version
                  
//           //////////////////////////////////////////////////////////////////////////////

//           // var currentValue;
//           // const fieldPath = database.ref('patreon'); 
          
//           //   fieldPath.transaction((currentData) => {
//           //     if (currentData) {
//           //       currentValue = currentData             
//           //     }
//           //     else{
//           //       currentValue = {
//           //         Datetoday: ''
//           //       }
//           //     }

//           // //   const currentValue = currentData;
//           //   const dbDate = currentValue.Datetoday; 
            
//           //     console.log('addmorepoints 2 params.pointsAdded : ', params.pointsAdded);
//           //     console.log('addmorepoints 2 currentValue : ', currentValue);           
            
//           //      if (currentValue.Datetoday === null || currentValue.Datetoday === undefined || currentValue.Datetoday === '') {
//           //          // If the current value is null, undefined, or empty, set it to the params.pointsAdded
//           //          currentValue.LCPOOL = parseFloat(params.pointsAdded);
//           //          currentValue.LCtoday = parseFloat(params.pointsAdded);
//           //          currentValue.Datetoday = newPaddedDate;
//           //          return currentValue; // Parse params.pointsAdded as integer
//           //      } else {
//           //           currentValue.LCPOOL = (parseFloat(currentValue.LCPOOL) || 0) - parseFloat(params.pointsAdded); 
//           //           if (dbDate.toString()===newPaddedDate.toString()) { //today
                      
//           //             currentValue.LCtoday = (parseFloat(currentValue.LCtoday) || 0) + parseFloat(params.pointsAdded); 
//           //           }
//           //           else { //not today
                      
//           //             currentValue.LCtoday = parseFloat(params.pointsAdded);
//           //             currentValue.Datetoday = newPaddedDate;
//           //           }
//           //           return currentValue;
//           //      }
//           //  })
//           //  .then(result => {
               
//           //  })
//           //  .catch(error => {
               
//           //  });
//            //////////////////////////////////////////////////////////////////////////
  
//         // if (doQuery) {
//         //   updates[QueryContent] = totPoints; 
//         //  // database.ref('dailyThoughts').child(subChild.val().dailyThoughtID).update({ points: totPoints })
//         // }
  
//         // var arrayLength = QueryContent.length;
//         // for (var i = 0; i < arrayLength; i++) {
//         //   updates[QueryContent[i]] = totPoints;
//         // }
//         const pts = (Number(params.pointsAdded) / 100);
//         const ptsA = pts;//.toString() 
//         const ptsB = ptsA;// + ' Lc'

//         const cpts = (Number(totPoints) / 100);
//         const cptsA = cpts//.toFixed(3);
//         const cptsB = cptsA;//.toString() 
//         const cptsC = cptsB;// + ' Lc'

//         updates['/pointsTrail/' + params.trailID] = {
//           userID: params.userID,
//           fdate: fdate,
//           trailID: params.trailID,
//           companyName: params.companyName,
//           firstName: params.firstName,
//           lastName: params.lastName,
//           title: params.title,
//           actionType: params.actionType,
//           actionDesc: params.actionDesc,
//           pointsAdded: ptsB,
//           pointsCurrent: cptsC,
//           gas: 0
//         }
  
//         updates['/MEVDATA/' + params.trailID] = {
//           userID: params.userID,
//           fdate: fdate,
//           trailID: params.trailID,
//           companyName: params.companyName,
//           firstName: params.firstName,
//           lastName: params.lastName,
//           title: params.title,
//           actionType: params.actionType,
//           actionDesc: params.actionDesc,
//           pointsAdded: ptsB,
//           pointsCurrent: cptsC,
//           gas: 0
//         }

//         //  await database
//         //   .ref()
//         //   .update(updates)
//         //   .then(() => {
//         //     // Update per-user daily earnings aggregate
//         //     recordUserDailyEarnings(params.userID, params.pointsAdded);
//         //     dispatch({
//         //       type: SHOW_TOAST,
//         //       variant: 'success',
//         //       message:
//         //         params.pointsAdded > 0
//         //           ? ((params.pointsAdded)/100).toFixed(3) + pointsNote
//         //           : 'Lc adjusted ' +
//         //           ((params.pointsAdded)/100).toFixed(3) +
//         //           ' Lc subtracted',
//         //       pos: 'bottom'
//         //     })
//         //   })


//      // update Lc on back end
//           var res = await axios.post(`${FB_URL}/m115-freshcard`, {
//                 params: {
//                     updates: updates, //user wallet address                       
//                 }
//           })
//       /** -------------------------------
//        *     CHECK BACKEND SUCCESS
//        *--------------------------------*/
//       if (res.data || res.data.success === true) {
//       // NOW (and only now) record earnings and show main toast
//       recordUserDailyEarnings(params.userID, params.pointsAdded);// ← only once, here
//       // const pointsNote =
//       //   params.currentUser === params.userID
//       //     ? ' Lc added to your points.'
//       //     : ' Lc added to ' + params.firstName;

//       // dispatch({
//       //     type: SHOW_TOAST,
//       //     variant: 'success',
//       //     message:
//       //       params.pointsAdded > 0
//       //         ? ((params.pointsAdded)/100).toFixed(3) + pointsNote
//       //         : 'Lc adjusted ' +
//       //         ((params.pointsAdded)/100).toFixed(3) +
//       //         ' Lc subtracted',
//       //     pos: 'bottom'
//       // });
//     } else {
//       console.error('addMorePoints error:', error);
//       dispatch({
//         type: SHOW_TOAST,
//         open: true,
//         variant: 'error',
//         message: 'Failed update database',
//       });
//     }

//     }
//   }
//   else {
//    dispatch({
//      type: SHOW_TOAST,
//      open: true,
//      variant: 'success',
//      message: 'Daily LC limit reached for today. Please continue tomorrow. Thank you.'
//    });
//  }
//  } catch (error) {
 
//  // Handle the error appropriately
//  dispatch({
//    type: SHOW_TOAST,
//    open: true,
//    variant: 'error',
//    message: 'An error occurred while checking LC quota 1:' + error
//  });
//  }
//  }; 
//    }
///////////////////////////////////////////////////////////////////////////////////////
//   export const addMorePoints_default = (params) => {
//       return async (dispatch, getState) => {
//         try {
//       var passL = await canAwardUserToday(params.userID, params.pointsAdded);
//       // Always allow deductions (reversals) regardless of daily quota
//       if (Number(params.pointsAdded) < 0) { passL = true; }
//       console.log('PassLC: 6', passL);

//      if (passL === true) {
//       let parleadPoints
//       if (params.leadPoints) {
//         // its ok
//         parleadPoints = params.leadPoints
//       } else {
//         parleadPoints = 0
//       }
//       let database = firebase.database
//       var totPoints
//       var totLc = totPoints / 100;
//       var totSlc = totLc.toString()
//       var ytotPoints
//       var leadPoints

//       if (params && params.forceAward === true) {
//         const inc = parseFloat(params.pointsAdded || 0)
//         const userPtsRef = database.ref('/user/' + params.uid + '/points')
//         const usersPtsRef = database.ref('/users/' + params.userID + '/points')
//         const userYPtsRef = database.ref('/user/' + params.uid + '/pointsy')
//         const usersYPtsRef = database.ref('/users/' + params.userID + '/pointsy')

//         await userPtsRef.transaction((current) => (parseFloat(current || 0) + inc))
//         await usersPtsRef.transaction((current) => (parseFloat(current || 0) + inc))
//         await userYPtsRef.transaction((current) => (parseFloat(current || 0) + inc))
//         await usersYPtsRef.transaction((current) => (parseFloat(current || 0) + inc))

//         const newPtsSnap = await userPtsRef.once('value')
//         const newYPtsSnap = await userYPtsRef.once('value')
//         totPoints = parseFloat(newPtsSnap.val() || 0)
//         ytotPoints = parseFloat(newYPtsSnap.val() || 0)
//         leadPoints = (parseFloat(parleadPoints) + inc)
//       } else {
//         totPoints = (parseFloat(params.pointsCurrent || 0) + parseFloat(params.pointsAdded || 0))
//         ytotPoints = (parseFloat(params.ypointsCurrent || 0) + parseFloat(params.pointsAdded || 0))
//         leadPoints = (parseFloat(parleadPoints) + parseFloat(params.pointsAdded || 0))
//       }
//       if (params.ypointsCurrent!==undefined) {
//         var ytotPoints = parseFloat(params.ypointsCurrent) + parseFloat(params.pointsAdded)
//       } else {
//         ytotPoints = 0
//       }
    
//       if (totPoints < 0) {
//         totPoints = 0
//       }
//       if (ytotPoints < 0) {
//         ytotPoints = 0
//       }
//       const updates = {}
//       const updates_poe = {}
    
//       // const d = new Date()
//       // const y = d.getFullYear()
//       // const m = d.getMonth()
//       // const day = d.getDate()
//       // const fdate = formatDate(d) // y + '/' + m + '/' + day;
//       // /////////////////////////////////////////////////////////////////////////
//       // var timeRaw = new Date();
//       // var isoString = timeRaw.toISOString();
//       // var year = timeRaw.getFullYear();
//       // var month = String(timeRaw.getMonth() + 1).padStart(2, '0'); // Ensure 2-digit month
//       // var day = String(timeRaw.getDate()).padStart(2, '0'); // Ensure 2-digit day
//       // var hours = String(timeRaw.getHours()).padStart(2, '0'); // Ensure 2-digit hours
//       // var minutes = String(timeRaw.getMinutes()).padStart(2, '0'); // Ensure 2-digit minutes
      
//       // var fdate = `${year}-${month}-${day} ${hours}:${minutes}`;
//       const timeRaw = moment().tz('Africa/Johannesburg'); // Set timezone to SAST
//       const year = timeRaw.format('YYYY');
//       const month = timeRaw.format('MM'); // 2-digit month
//       const day = timeRaw.format('DD'); // 2-digit day
//       const hours = timeRaw.format('HH'); // 2-digit hours
//       const minutes = timeRaw.format('mm'); // 2-digit minutes

//       const fdate = `${year}-${month}-${day} ${hours}:${minutes}`;
//        // Example output: "2024-11-06 08:45"
//       ////////////////////////////////////////////////////////////////////////////
//       var QueryContent = [];
//       var arrayLength;

//       let pointsNote
      
//       if (params.currentUser === params.userID) { // Points made by LEAD owner
//         pointsNote = ' Lc added to your points.'
//       } else { // Points made by other users comment on LEAD
//         pointsNote = ' Lc added to ' + params.firstName
//       }
//       if (totPoints) {
//         let r = 0
//         let kk; let ds; let nn; let xx; let restmm; let snapshotKidz
//      // return async (dispatch, getState) => {
                      
    
//           if (!(params && params.forceAward === true)) {
//             updates['/user/' + params.uid + '/points'] = totPoints
//             updates['/users/' + params.userID + '/points'] = totPoints
//             updates['/user/' + params.uid + '/pointsy'] = ytotPoints
//             updates['/users/' + params.userID + '/pointsy'] = ytotPoints
//           }
//          // updates['/users/' + params.uid + '/points'] = totPoints
//           //////////////////////////////////////////////////////////////////////////
//           // if (params.actionDesc === 'LEAD comment' || params.actionDesc === 'comment deleted') {
//           //   database.ref('dailyThoughts').child(params.leadID).update({ leadPoints: leadPoints })
     
//           //   // UPDATE ALL LEADS (OR TOP 10) FOR THIS USER
//           //   let postRef = database.ref('dailyThoughts').orderByChild('journalUserID').equalTo(params.userID)
//           //   // postRef.on("value", function (snapshot) {
//           //   postRef.once('value')
//           //     .then(async snapshot => {
//           //       snapshot.forEach(function (subChild) {
//           //         snapshotKidz = snapshot.numChildren()
    
//           //         if (snapshotKidz > 50) {
//           //           xx = snapshotKidz - 50
//           //           if (xx > 50) {
//           //             nn = 50
//           //           }
//           //           if (xx < 50) {
//           //             nn = snapshotKidz - 50
//           //           }
//           //           restmm = snapshotKidz - nn
//           //         } else {
//           //           restmm = 0
//           //         }
//           //         if (r => restmm) {
//           //           // leadUpdate.push(subChild.val().dailyThoughtID);
    
//           //          // database.ref('dailyThoughts').child(subChild.val().dailyThoughtID).update({ points: totPoints })
//           //           QueryContent.push('/dailyThoughts/' + subChild.val().dailyThoughtID + '/points');
    
//           //           // updates['/dailyThoughts/' + subChild.val().dailyThoughtID + '/points'] = totPoints;
//           //         }
//           //         r = r + 1
//           //       })
    
//           //       ///////////////////////////////////////////////
    
//           //       arrayLength = QueryContent.length;
          
//           //       for (var i = 0; i < arrayLength; i++) {
//           //         updates[QueryContent[i]] = totPoints;
//           //       }
    
//           //       await database
//           //       .ref()
//           //       .update(updates)
//           //       .then(() => {
//           //         dispatch({
//           //           type: SHOW_TOAST,
//           //           variant: 'success',
//           //           message: params.pointsAdded > 0 ? (params.pointsAdded)/100 + pointsNote :
//           //             'Lc adjusted - 1',
//           //           pos: 'bottom'
//           //         })
//           //       })
//           //       .catch(err => {
//           //         dispatch({
//           //           type: 'SHOW_TOAST',
//           //           open: true,
//           //           variant: 'error',
//           //           message: 'Error response: ' + err.message
//           //         })
//           //       })
    
//           //       ////////////////////////////////////////////////
    
//           //     })
//           // }
//           // if (params.actionDesc === 'LEAD comment' || params.actionDesc === 'comment deleted') {
//           //   if (params.groupid!=='') {      
//           //     //GROUP POSTS
//           //     //group-posts/-LmFFPvjY8Y118CkUgqV/-OIVfTmIqZKsyI_5xw-N
//           //     //group-posts/{groupid}/{postID}
//           //      const groupRef = 'group-posts/' + params.groupid

//           //   database.ref(groupRef).child(params.leadID).update({ leadPoints: leadPoints })
     
//           //   // UPDATE ALL LEADS (OR TOP 10) FOR THIS USER
//           //   let postRef = database.ref(groupRef).orderByChild('journalUserID').equalTo(params.userID)
//           //   // postRef.on("value", function (snapshot) {
//           //   postRef.once('value')
//           //     .then(async snapshot => {
//           //       snapshot.forEach(function (subChild) {
//           //         snapshotKidz = snapshot.numChildren()
    
//           //         if (snapshotKidz > 50) {
//           //           xx = snapshotKidz - 50
//           //           if (xx > 50) {
//           //             nn = 50
//           //           }
//           //           if (xx < 50) {
//           //             nn = snapshotKidz - 50
//           //           }
//           //           restmm = snapshotKidz - nn
//           //         } else {
//           //           restmm = 0
//           //         }
//           //         if (r => restmm) {
//           //           // leadUpdate.push(subChild.val().dailyThoughtID);
    
//           //          // database.ref('dailyThoughts').child(subChild.val().dailyThoughtID).update({ points: totPoints })
//           //           QueryContent.push(groupRef + '/' + subChild.val().dailyThoughtID + '/points');
    
//           //           // updates['/dailyThoughts/' + subChild.val().dailyThoughtID + '/points'] = totPoints;
//           //         }
//           //         r = r + 1
//           //       })
    
//           //       ///////////////////////////////////////////////
    
//           //       arrayLength = QueryContent.length;
          
//           //       for (var i = 0; i < arrayLength; i++) {
//           //         updates[QueryContent[i]] = totPoints;
//           //       }
    
//           //       await database
//           //       .ref()
//           //       .update(updates)
//           //       .then(() => {
//           //         dispatch({
//           //           type: SHOW_TOAST,
//           //           variant: 'success',
//           //           message: params.pointsAdded > 0 ? (params.pointsAdded)/100 + pointsNote :
//           //             'Lc adjusted - 1',
//           //           pos: 'bottom'
//           //         })
//           //       })
//           //       .catch(err => {
//           //         dispatch({
//           //           type: 'SHOW_TOAST',
//           //           open: true,
//           //           variant: 'error',
//           //           message: 'Error response: ' + err.message
//           //         })
//           //       })
    
//           //       ////////////////////////////////////////////////
    
//           //     })
//           //   }
//           // }
//           //////////////////////////////////////////////////////////////////////////

//               // //////UPDATE LCPOOL////////////////////////////////////////////////////
//               const dateObj = new Date();
//               const month   = dateObj.getUTCMonth() + 1; // months from 1-12
//               const day     = dateObj.getUTCDate();
//               const year    = dateObj.getUTCFullYear();
      
//               //const newDate = year + "/" + month + "/" + day;
      
//               const newDate = `${year}/${month}/${day}`;
      
//               // Using padded values, so that 2023/1/7 becomes 2023/01/07
//               const pMonth        = month.toString().padStart(2,"0");
//               const pDay          = day.toString().padStart(2,"0");
//               const newPaddedDate = `${year}/${pMonth}/${pDay}`;
              
    
              
//           //UPDATE GIF in patreon field/////////////////////////////////////
//           const snap = await database.ref('patreon').once('value');
//           const data = snap.val() || {};

//           const lcpool  = parseFloat(data.LCPOOL)  || 0;
//           const lctoday = parseFloat(data.LCtoday) || 0;
//           const addpoints  = parseFloat(params.pointsAdded);

//           updates['/patreon/Datetoday'] = newPaddedDate
//           updates['/patreon/LCPOOL'] = lcpool - addpoints,
//           updates['/patreon/LCtoday'] = (data.Datetoday === newPaddedDate ? lctoday + addpoints : addpoints)

//           //////////////////////////////////////////////////////////////////////////////
//         //       var currentValue;
//         //       const fieldPath = database.ref('patreon'); 
    
//         //         fieldPath.transaction((currentData) => {
//         //           if (currentData) {
//         //             currentValue = currentData             
//         //           }
//         //           else{
//         //             currentValue = {
//         //               Datetoday: ''
//         //             }
//         //           }
                  
//         //           console.log('addmorepoints 1 params.pointsAdded : ', params.pointsAdded);
//         //           console.log('addmorepoints 1 currentValue : ', currentValue);
                  
//         //           const dbDate = currentValue.Datetoday;
                  
//         //            if (currentValue.Datetoday === null || currentValue.Datetoday === undefined || currentValue.Datetoday === '') {
//         //                // If the current value is null, undefined, or empty, set it to the params.pointsAdded
//         //                currentValue.LCPOOL = parseFloat(params.pointsAdded);
//         //                currentValue.LCtoday = parseFloat(params.pointsAdded);
//         //                currentValue.Datetoday = newPaddedDate;
//         //                return currentValue; // Parse params.pointsAdded as integer
//         //            } else {
//         //                 currentValue.LCPOOL = (parseFloat(currentValue.LCPOOL) || 0) - parseFloat(params.pointsAdded); 
//         //               if (dbDate.toString()===newPaddedDate.toString()) { //today
                        
//         //                 currentValue.LCtoday = (parseFloat(currentValue.LCtoday) || 0) + parseFloat(params.pointsAdded);                     }
//         //                 else { //not same date
                          
//         //                   currentValue.LCtoday = parseFloat(params.pointsAdded);
//         //                   currentValue.Datetoday = newPaddedDate;
//         //                 }
//         //                 return currentValue;
//         //            }
//         //        })
//         //        .then(result => {
                   
//         //        })
//         //        .catch(error => {
                   
//         //        });
//         // ////////////////////////////////////////////////////////////////////////////// 

//               // // Perform a transaction
//               // database.ref(fieldPath).transaction(currentValue => {
                
//               //     if (currentValue === null || currentValue === undefined || currentValue === '') {
//               //         // If the current value is null, undefined, or empty, set it to the params.pointsAdded
//               //         return parseFloat(params.pointsAdded); // Parse params.pointsAdded as integer
//               //     } else {
//               //         // If the current value exists, subtract from LC POOL
                      
//               //       //  if (trans===false)  {  
//               //          // trans = true;                   
//               //           return (parseFloat(currentValue) || 0) - parseFloat(params.pointsAdded); // Add params.pointsAdded to the existing value
//               //        // }
//               //     }
//               // })
//               // .then(result => {
//               // })
//               // .catch(error => {
//               // });
              
//           //////////////////////////////////////////////////////////////////////////
    
          
//           const pts = (Number(params.pointsAdded) / 100);
//           const ptsA = pts;//.toString() 
//           const ptsB = ptsA;// + ' Lc'

//           const cpts = (Number(totPoints) / 100);
//           const cptsA = cpts;//.toFixed(3);
//           const cptsB = cptsA;//.toString() 
//           const cptsC = cptsB;// + ' Lc'

          
//           updates['/pointsTrail/' + params.trailID] = {
//             userID: params.userID,
//             fdate: fdate,
//             trailID: params.trailID,
//             companyName: params.companyName,
//             firstName: params.firstName,
//             lastName: params.lastName,
//             title: params.title,
//             actionType: params.actionType,
//             actionDesc: params.actionDesc,
//             pointsAdded: ptsB,
//             pointsCurrent: cptsC,
//             gas: 0
//           }
          
//           updates['/MEVDATA/' + params.trailID] = {
//             userID: params.userID,
//             fdate: fdate,
//             trailID: params.trailID,
//             companyName: params.companyName,
//             firstName: params.firstName,
//             lastName: params.lastName,
//             title: params.title,
//             actionType: params.actionType,
//             actionDesc: params.actionDesc,
//             pointsAdded: ptsB,
//             pointsCurrent: cptsC,
//             gas: 0
//           }  

//           await database
//             .ref()
//             .update(updates)
//             .then(() => {
//               // Update per-user daily earnings aggregate
//               recordUserDailyEarnings(params.userID, params.pointsAdded);
//               dispatch({
//                 type: SHOW_TOAST,
//                 variant: 'success',
//                 message:
//                   params.pointsAdded > 0
//                     ? (params.pointsAdded)/100 + pointsNote
//                     : 'Lc adjusted ' +
//                     (params.pointsAdded)/100 +
//                     ' Lc subtracted',
//                 pos: 'bottom'
//               })
//             })
//             .catch((err) => {
//               dispatch({
//                 type: 'SHOW_TOAST',
//                 open: true,
//                 variant: 'error',
//                 message: 'addMorePoints Error response: ' + err.message
//               })
//             })
//        // } //return async (dispatch, getState) => {
//       }
//      }
//      else {
//       dispatch({
//         type: SHOW_TOAST,
//         open: true,
//         variant: 'success',
//         message: 'Daily LC limit reached for today.'
//       });
//     }
//     } catch (error) {
    
//     // Handle the error appropriately
//     dispatch({
//       type: SHOW_TOAST,
//       open: true,
//       variant: 'error',
//       message: 'An error occurred while checking LC quota 2:' + error
//     });
//     }
//     };
//     };

//  export const likesPoints_default = params => {
//  export const likesPoints_old = params => {
//   return async (dispatch, getState) => {
//     try {
//       var passL = await canAwardUserToday(params.userID, params.pointsAdded);
//       // Allow deductions (e.g., unlike) even if quota reached
//       if (Number(params.pointsAdded) < 0) { passL = true; }

//     console.log('PassLC: 6', passL);

//     if (passL === true) {
//       let database = firebase.database
//       let parleadPoints
//     if (params.leadPoints) {
//       // its ok
//       parleadPoints = params.leadPoints
//     } else {
//       parleadPoints = 0
//     }
  
//     if (params.pointsCurrent) {
//       if (params.pointsAdded > 0) {
//         var totPoints = parseFloat(params.pointsCurrent) + parseFloat(params.pointsAdded)
//         var leadPoints = parseFloat(parleadPoints) + parseFloat(params.pointsAdded)
//       } else {
//         var totPoints = parseFloat(params.pointsCurrent) - parseFloat(Math.abs(params.pointsAdded))
//         var leadPoints = parseFloat(parleadPoints) - parseFloat(Math.abs(params.pointsAdded))
//       }
//     } else {
//       totPoints = 0
//     }
//     if (params.ypointsCurrent!==undefined) {
//       var ytotPoints = parseFloat(params.ypointsCurrent) + parseFloat(params.pointsAdded)
//     } else {
//       ytotPoints = 0
//     }
  
//     if (totPoints < 0) {
//       totPoints = 0
//     }
//     if (ytotPoints < 0) {
//       ytotPoints = 0
//     }
//     const updates = {}
//     var totLc = totPoints / 100;
//     console.log('blacktotLc 1:', totLc);

//     var totSlc = totLc.toString()
//     console.log('blacktotLc 2:', totSlc);

//     // const d = new Date()
//     // const y = d.getFullYear()
//     // const m = d.getMonth()
//     // const day = d.getDate()
//     // const fdate = formatDate(d) // y + '/' + m + '/' + day;
//       // /////////////////////////////////////////////////////////////////////////
//       const timeRaw = moment().tz('Africa/Johannesburg'); // Set timezone to SAST
//       const year = timeRaw.format('YYYY');
//       const month = timeRaw.format('MM'); // 2-digit month
//       const day = timeRaw.format('DD'); // 2-digit day
//       const hours = timeRaw.format('HH'); // 2-digit hours
//       const minutes = timeRaw.format('mm'); // 2-digit minutes

//       const fdate = `${year}-${month}-${day} ${hours}:${minutes}`;
//        // Example output: "2024-11-06 08:45"
//       ////////////////////////////////////////////////////////////////////////////
//     var doQuery = false;
//     var q = 0;
//     var QueryContent = [];
//     var arrayLength;
  
//     let pointsNote = ''
  
//     if (params.currentUser === params.userID) { // Points made by LEAD owner
//       pointsNote = ' Lc added to your points.'
//     } else { // Points made by other users comment on LEAD
//       pointsNote = ' Lc added to ' + params.firstName
//     }
//     if (totPoints) {
//       let r = 0
//       let kk; let ds; let nn; let xx; let restmm; let snapshotKidz
//       let leadUpdate = []
  
//       //   return async (dispatch, getState) => {
//         updates['/user/' + params.uid + '/points'] = totPoints
//         updates['/users/' + params.userID + '/points'] = totPoints
//         updates['/user/' + params.uid + '/pointsy'] = ytotPoints
//         updates['/users/' + params.userID + '/pointsy'] = ytotPoints
  
        
//         /////////////////////////////////////////////////////////////////////////////
//         // if (params.actionDesc === 'LEAD comment') { //RENDER ALL FORUMS EXCEPT GROUP/S
//         //   database.ref('dailyThoughts').child(params.leadID).update({ leadPoints: leadPoints })
//         //   //database.ref('dailyThoughts').child(params.leadID).update({ points: totPoints })
          
//         //   // UPDATE ALL LEADS (OR TOP 10) FOR THIS USER
//         //   let postRef = database.ref('dailyThoughts').orderByChild('journalUserID').equalTo(params.userID)
//         //   // postRef.on("value", function (snapshot) {
//         //   postRef.once('value')
//         //     .then(async snapshot => {
//         //       snapshot.forEach(function (subChild) {
//         //     //  for( const subChild of snapshot ){
//         //         //const value = snapshot.val()
  
//         //         // for (var i in snapshot.docs) {
//         //         //   const subChild = snapshot.docs[i]
  
//         //         snapshotKidz = snapshot.numChildren();
  
//         //         if (snapshotKidz > 50) {
//         //           xx = snapshotKidz - 50
//         //           if (xx > 50) {
//         //             nn = 50
//         //           }
//         //           if (xx < 50) {
//         //             nn = snapshotKidz - 50
//         //           }
//         //           restmm = snapshotKidz - nn
//         //         } else {
//         //           restmm = 0
//         //         }
//         //         if (r => restmm) {
//         //           // leadUpdate.push(subChild.val().dailyThoughtID);
  
//         //           // leadUpdate.push({"a": subChild.val().dailyThoughtID});
  
//         //           // database.ref('dailyThoughts').child(subChild.val().dailyThoughtID).update({ points: totPoints })
  
//         //           // database.ref('dailyThoughts').child(subChild.val().dailyThoughtID).update({ points: totPoints })
  
//         //           //  database.ref('dailyThoughts').child(subChild.val().dailyThoughtID).update({ points: totPoints })
  
//         //           // database.ref("dailyThoughts").child(subChild.val().dailyThoughtID).update({"leadPoints" : leadPoints});
//         //           // updates['/dailyThoughts/' + subChild.val().dailyThoughtID + '/points'] = totPoints;
//         //           q = q + 1;
//         //           QueryContent.push('/dailyThoughts/' + subChild.val().dailyThoughtID + '/points');
//         //           //GROUP POSTS
//         //           ///group-posts/-LmFFPvjY8Y118CkUgqV/-OIVfTmIqZKsyI_5xw-N
//         //           //group-posts/{groupid}/{postID}
//         //         }
//         //         r = r + 1
//         //       }
  
//         //       )
//         //       ///////////////////////////////////////////////
  
//         //       arrayLength = QueryContent.length;
        
//         //       for (var i = 0; i < arrayLength; i++) {
//         //         updates[QueryContent[i]] = totPoints;
//         //       }
  
//         //       await database
//         //       .ref()
//         //       .update(updates)
//         //       .then(() => {
//         //         dispatch({
//         //           type: SHOW_TOAST,
//         //           variant: 'success',
//         //           message: params.pointsAdded > 0 ? (params.pointsAdded)/100 + pointsNote :
//         //             'Lc adjusted - 1',
//         //           pos: 'bottom'
//         //         })
//         //       })
//         //       .catch(err => {
//         //         dispatch({
//         //           type: 'SHOW_TOAST',
//         //           open: true,
//         //           variant: 'error',
//         //           message: 'Error response: ' + err.message
//         //         })
//         //       })
  
//         //       ////////////////////////////////////////////////
//         //     }
              
//         //     )
//         // }
  
//         // if (params.actionDesc === 'LEAD comment' && params.groupid!='') { //RENDER GROUP
//         //  //GROUP POSTS
//         //  //group-posts/-LmFFPvjY8Y118CkUgqV/-OIVfTmIqZKsyI_5xw-N
//         //  //group-posts/{groupid}/{postID}
//         //   const groupRef = 'group-posts/' + params.groupid

//         //   database.ref(groupRef).child(params.leadID).update({ leadPoints: leadPoints })
//         //   //database.ref('dailyThoughts').child(params.leadID).update({ points: totPoints })
          
//         //   // UPDATE ALL LEADS (OR TOP 10) FOR THIS USER
//         //   let postRef = database.ref(groupRef).orderByChild('journalUserID').equalTo(params.userID)
//         //   // postRef.on("value", function (snapshot) {
//         //   postRef.once('value')
//         //     .then(async snapshot => {
//         //       snapshot.forEach(function (subChild) {
//         //     //  for( const subChild of snapshot ){
//         //         //const value = snapshot.val()
  
//         //         // for (var i in snapshot.docs) {
//         //         //   const subChild = snapshot.docs[i]
  
//         //         snapshotKidz = snapshot.numChildren();
  
//         //         if (snapshotKidz > 50) {
//         //           xx = snapshotKidz - 50
//         //           if (xx > 50) {
//         //             nn = 50
//         //           }
//         //           if (xx < 50) {
//         //             nn = snapshotKidz - 50
//         //           }
//         //           restmm = snapshotKidz - nn
//         //         } else {
//         //           restmm = 0
//         //         }
//         //         if (r => restmm) {
//         //           // leadUpdate.push(subChild.val().dailyThoughtID);
  
//         //           // leadUpdate.push({"a": subChild.val().dailyThoughtID});
  
//         //           // database.ref('dailyThoughts').child(subChild.val().dailyThoughtID).update({ points: totPoints })
  
//         //           // database.ref('dailyThoughts').child(subChild.val().dailyThoughtID).update({ points: totPoints })
  
//         //           //  database.ref('dailyThoughts').child(subChild.val().dailyThoughtID).update({ points: totPoints })
  
//         //           // database.ref("dailyThoughts").child(subChild.val().dailyThoughtID).update({"leadPoints" : leadPoints});
//         //           // updates['/dailyThoughts/' + subChild.val().dailyThoughtID + '/points'] = totPoints;
//         //           q = q + 1;
//         //           QueryContent.push(groupRef + '/' + subChild.val().dailyThoughtID + '/points');
//         //           //GROUP POSTS
//         //           ///group-posts/-LmFFPvjY8Y118CkUgqV/-OIVfTmIqZKsyI_5xw-N
//         //           //group-posts/{groupid}/{postID}
//         //         }
//         //         r = r + 1
//         //       })
  
//         //       )
//         //       ///////////////////////////////////////////////
  
//         //       arrayLength = QueryContent.length;
        
//         //       for (var i = 0; i < arrayLength; i++) {
//         //         updates[QueryContent[i]] = totPoints;
//         //       }
  
//         //       await database
//         //       .ref()
//         //       .update(updates)
//         //       .then(() => {
//         //         dispatch({
//         //           type: SHOW_TOAST,
//         //           variant: 'success',
//         //           message: params.pointsAdded > 0 ? (params.pointsAdded)/100 + pointsNote :
//         //             'Lc adjusted - 1',
//         //           pos: 'bottom'
//         //         })
//         //       })
//         //       .catch(err => {
//         //         dispatch({
//         //           type: 'SHOW_TOAST',
//         //           open: true,
//         //           variant: 'error',
//         //           message: 'Error response: ' + err.message
//         //         })
//         //       })
  
//         //       ////////////////////////////////////////////////
//         //     }
              
//         //     )
//         // }
//         ////////////////////////////////////////////////////////////////////////////

//           // //////UPDATE LCPOOL////////////////////////////////////////////////////
//           const dateObj = new Date();
//           const month   = dateObj.getUTCMonth() + 1; // months from 1-12
//           const day     = dateObj.getUTCDate();
//           const year    = dateObj.getUTCFullYear();
  
//           //const newDate = year + "/" + month + "/" + day;
  
//           const newDate = `${year}/${month}/${day}`;
  
//           // Using padded values, so that 2023/1/7 becomes 2023/01/07
//           const pMonth        = month.toString().padStart(2,"0");
//           const pDay          = day.toString().padStart(2,"0");
//           const newPaddedDate = `${year}/${pMonth}/${pDay}`;
          
//           //UPDATE GIF in patreon field/////////////////////////////////////
//           const snap = await database.ref('patreon').once('value');
//           const data = snap.val() || {};

//           const lcpool  = parseFloat(data.LCPOOL)  || 0;
//           const lctoday = parseFloat(data.LCtoday) || 0;
//           const addpoints  = parseFloat(params.pointsAdded);

//           updates['/patreon/Datetoday'] = newPaddedDate
//           updates['/patreon/LCPOOL'] = lcpool - addpoints,
//           updates['/patreon/LCtoday'] = (data.Datetoday === newPaddedDate ? lctoday + addpoints : addpoints)

//           //////////////////////////////////////////////////////////////////////////////

//           // var currentValue;
//           // const fieldPath = database.ref('patreon'); 
          
//           //   fieldPath.transaction((currentData) => {
//           //     if (currentData) {
//           //       currentValue = currentData             
//           //     }
//           //     else{
//           //       currentValue = {
//           //         Datetoday: ''
//           //       }
//           //     }

//           // //   const currentValue = currentData;
//           //   const dbDate = currentValue.Datetoday; 
            
//           //     console.log('addmorepoints 2 params.pointsAdded : ', params.pointsAdded);
//           //     console.log('addmorepoints 2 currentValue : ', currentValue);           
            
//           //      if (currentValue.Datetoday === null || currentValue.Datetoday === undefined || currentValue.Datetoday === '') {
//           //          // If the current value is null, undefined, or empty, set it to the params.pointsAdded
//           //          currentValue.LCPOOL = parseFloat(params.pointsAdded);
//           //          currentValue.LCtoday = parseFloat(params.pointsAdded);
//           //          currentValue.Datetoday = newPaddedDate;
//           //          return currentValue; // Parse params.pointsAdded as integer
//           //      } else {
//           //           currentValue.LCPOOL = (parseFloat(currentValue.LCPOOL) || 0) - parseFloat(params.pointsAdded); 
//           //           if (dbDate.toString()===newPaddedDate.toString()) { //today
                      
//           //             currentValue.LCtoday = (parseFloat(currentValue.LCtoday) || 0) + parseFloat(params.pointsAdded); 
//           //           }
//           //           else { //not today
                      
//           //             currentValue.LCtoday = parseFloat(params.pointsAdded);
//           //             currentValue.Datetoday = newPaddedDate;
//           //           }
//           //           return currentValue;
//           //      }
//           //  })
//           //  .then(result => {
               
//           //  })
//           //  .catch(error => {
               
//           //  });
//            //////////////////////////////////////////////////////////////////////////
  
//         // if (doQuery) {
//         //   updates[QueryContent] = totPoints; 
//         //  // database.ref('dailyThoughts').child(subChild.val().dailyThoughtID).update({ points: totPoints })
//         // }
  
//         // var arrayLength = QueryContent.length;
//         // for (var i = 0; i < arrayLength; i++) {
//         //   updates[QueryContent[i]] = totPoints;
//         // }
//         const pts = (Number(params.pointsAdded) / 100);
//         const ptsA = pts;//.toString() 
//         const ptsB = ptsA;// + ' Lc'

//         const cpts = (Number(totPoints) / 100);
//         const cptsA = cpts//.toFixed(3);
//         const cptsB = cptsA;//.toString() 
//         const cptsC = cptsB;// + ' Lc'

//         updates['/pointsTrail/' + params.trailID] = {
//           userID: params.userID,
//           fdate: fdate,
//           trailID: params.trailID,
//           companyName: params.companyName,
//           firstName: params.firstName,
//           lastName: params.lastName,
//           title: params.title,
//           actionType: params.actionType,
//           actionDesc: params.actionDesc,
//           pointsAdded: ptsB,
//           pointsCurrent: cptsC,
//           gas: 0
//         }
  
//         updates['/MEVDATA/' + params.trailID] = {
//           userID: params.userID,
//           fdate: fdate,
//           trailID: params.trailID,
//           companyName: params.companyName,
//           firstName: params.firstName,
//           lastName: params.lastName,
//           title: params.title,
//           actionType: params.actionType,
//           actionDesc: params.actionDesc,
//           pointsAdded: ptsB,
//           pointsCurrent: cptsC,
//           gas: 0
//         }

//          await database
//           .ref()
//           .update(updates)
//           .then(() => {
//             // Update per-user daily earnings aggregate
//             recordUserDailyEarnings(params.userID, params.pointsAdded);
//             dispatch({
//               type: SHOW_TOAST,
//               variant: 'success',
//               message:
//                 params.pointsAdded > 0
//                   ? ((params.pointsAdded)/100).toFixed(3) + pointsNote
//                   : 'Lc adjusted ' +
//                   ((params.pointsAdded)/100).toFixed(3) +
//                   ' Lc subtracted',
//               pos: 'bottom'
//             })
//           })
//           .catch(err => {
//             dispatch({
//               type: 'SHOW_TOAST',
//               open: true,
//               variant: 'error',
//               message: 'Error response: ' + err.message
//             })
//           })
//       //}
//     }
//   }
//   else {
//    dispatch({
//      type: SHOW_TOAST,
//      open: true,
//      variant: 'success',
//      message: 'Daily LC limit reached for today.'
//    });
//  }
//  } catch (error) {
 
//  // Handle the error appropriately
//  dispatch({
//    type: SHOW_TOAST,
//    open: true,
//    variant: 'error',
//    message: 'An error occurred while checking LC quota 1:' + error
//  });
//  }
//  }; 
//    }

function getP(props) {
  for (let x in props) {
    return props[x].points
  }
}

// export const getRealPoints = params => {
//    var finalpoints = 0;
//     return async(dispatch, getState) => {
//       await firebase.database
//         .ref('user')
//         .orderByChild('uid')
//         .equalTo(params.uid)
//         .on('value', function (data) {
//            if (data.val()) {
//             let alldata = data.val()
//             let receivedData = {}

//          if (Object.keys(alldata).length > 0) {
//           sortedData = alldata.points
//           let sortedData = _toArrayUsers(alldata)
//           sortedData.sort(function (a, b) {

//             if (a.points > b.points) {
//               return 1
//             }
//             if (a.points < b.points) {
//               return -1
//             }
//             return 0
//           })

//           receivedData = { ...sortedData }

//           receivedData = Object.assign({}, sortedData)
//           finalpoints = getP(receivedData)

//            dispatch({
//               type: GET_POINTS,
//               realpoints: finalpoints
//             })
//           } else {
//             dispatch({
//               type: GET_POINTS,
//               realpoints: {}
//             })
//           }
//         }
//       })
//     }
//   }

export const getPoe = (params) => {
  return (dispatch, getState) => {
    const userRef = firebase.database
      .ref('pointsTrail')
      .orderByChild('userID')
      .equalTo(params.userID);
      // Removed .limitToLast(100) to ensure all entries (including the latest) are fetched,
      // assuming the number of entries per user is reasonable. If too many, consider data restructuring
      // (e.g., nesting pointsTrail under each userID) for server-side limiting by fdate.

    userRef.on('value', (snapshot) => {
      const poedata = snapshot.val() || {};

      // Remove any corrupted "undefined" key if present
      if (poedata.hasOwnProperty('undefined')) {
        delete poedata['undefined'];
      }

      let receivedData = [];

      if (Object.keys(poedata).length > 0) {
        receivedData = _toArrayUsers(poedata);  // Should return array like [{...entry, trailID: key}, ...]

        // Sort descending by fdate (latest first)
        receivedData.sort((a, b) => {
          const dateA = new Date(a.fdate || '1970-01-01T00:00:00');
          const dateB = new Date(b.fdate || '1970-01-01T00:00:00');
          return dateB - dateA;  // Newest on top
        });
      }

      dispatch({
        type: GET_POE,
        poe: receivedData  // array, already sorted newest → oldest
      });
    });

    // Clean up listener on unmount
    return () => userRef.off('value');
  };
};

export const getPoe_feb3 = (params) => {
  return (dispatch, getState) => {
    const userRef = firebase.database
      .ref('pointsTrail')
      .orderByChild('userID')
      .equalTo(params.userID)
      .limitToLast(100);  // Gets the 100 most recently added (by push key order)

    userRef.on('value', (snapshot) => {
      const poedata = snapshot.val() || {};

      // Remove any corrupted "undefined" key if present
      if (poedata.hasOwnProperty('undefined')) {
        delete poedata['undefined'];
      }

      let receivedData = [];

      if (Object.keys(poedata).length > 0) {
        receivedData = _toArrayUsers(poedata);  // Should return array like [{...entry, trailID: key}, ...]

        // Sort descending by fdate (latest first)
        receivedData.sort((a, b) => {
          const dateA = new Date(a.fdate || '1970-01-01T00:00:00');
          const dateB = new Date(b.fdate || '1970-01-01T00:00:00');
          return dateB - dateA;  // Newest on top
        });
      }

      dispatch({
        type: GET_POE,
        poe: receivedData  // array, already sorted newest → oldest
      });
    });

    // Optional: Clean up listener when component unmounts (in your componentDidUnmount or useEffect return)
    // return () => userRef.off('value');
  };
};

export const getPoe_new = (params) => {
  return (dispatch, getState) => {
    firebase.database
      .ref('pointsTrail')
      .orderByChild('userID')
      .equalTo(params.userID)
      .limitToLast(100)  // Add this: fetches only the most recent 100
      .on('value', function (data) {
        if (data.val()) {
          let poedata = data.val();

          // Safely remove any child with key "undefined" (corrupted data)
          if (poedata.hasOwnProperty('undefined')) {
            delete poedata['undefined'];
          }

          let receivedData = {};

          if (Object.keys(poedata).length > 0) {
            let sortedData = _toArrayUsers(poedata);  // Assuming this converts object to array correctly

            // Your existing sort by firstName... (consider removing if not needed, as it's not time-based)
            sortedData.sort(function (a, b) {
              if (a.firstName > b.firstName) return 1;
              if (a.firstName < b.firstName) return -1;
              return 0;
            });

            receivedData = Object.assign({}, sortedData);  // Or just sortedData if it's already an array
          }

          dispatch({
            type: GET_POE,
            poe: receivedData
          });
        } else {
          dispatch({
            type: GET_POE,
            poe: {}
          });
        }
      });
  };
};

export const getPoe_default = (params) => {
  return (dispatch, getState) => {
    firebase.database
      .ref('pointsTrail')
      .orderByChild('userID')
      .equalTo(params.userID)
      .on('value', function (data) {
        if (data.val()) {
          let poedata = data.val();

          // Safely remove any child with key "undefined" (corrupted data)
          if (poedata.hasOwnProperty('undefined')) {
            delete poedata['undefined'];
          }

          let receivedData = {};

          if (Object.keys(poedata).length > 0) {
            let sortedData = _toArrayUsers(poedata);  // Assuming this converts object to array correctly

            // Your existing sort by firstName...
            sortedData.sort(function (a, b) {
              if (a.firstName > b.firstName) return 1;
              if (a.firstName < b.firstName) return -1;
              return 0;
            });

            receivedData = Object.assign({}, sortedData);  // Or just sortedData if it's already an array
          }

          dispatch({
            type: GET_POE,
            poe: receivedData
          });
        } else {
          dispatch({
            type: GET_POE,
            poe: {}
          });
        }
      });
  };
};

//  export const getPoe = (params) => {
//   return (dispatch, getState) => {
//     firebase.database
//       .ref('pointsTrail')
//       .orderByChild('userID')
//       .equalTo(params.userID)
//       .on('value', function (data) {
//         if (data.val()) {
//           let poedata = data.val()
//           let receivedData = {}
//           delete poedata.undefined
//           if (Object.keys(poedata).length > 0) {
//             let sortedData = _toArrayUsers(poedata)

//             sortedData.sort(function (a, b) {
//               if (a.firstName > b.firstName) {
//                 return 1
//               }
//               if (a.firstName < b.firstName) {
//                 return -1
//               }
//               return 0
//             })

//             receivedData = { ...sortedData }

//             receivedData = Object.assign({}, sortedData)
//           }

//           dispatch({
//             type: GET_POE,
//             poe: receivedData
//           })
//         } else {
//           dispatch({
//             type: GET_POE,
//             poe: {}
//           })
//         }
//       })
//   }
// }

 const getNewUserdata = (params) => {
  let userData
  return (dispatch, getState) => {
    if (params.uid) {
      firebase.database.ref(`user/${params.uid}`).on('value', function (data) {
        if (data.val()) {
          userData = data.val()
          dispatch({
            type: 'FRESH',
            name: userData.firstName,
            lastname: userData.lastName,
            points: userData.points,
            club: userData.companyName
          })
        } else {
          return (dispatch, getState) => {
            dispatch({
              type: 'FRESH',
              name: '',
              lastname: '',
              points: '',
              club: ''
            })
          }
        }
      })
    } else {
      return (dispatch, getState) => {
        dispatch({
          type: 'FRESH',
          name: '',
          lastname: '',
          points: '',
          club: ''
        })
      }
    }
  }
}
